/**
 * 国际站数据概览数据
 */

!function () {

    // 引流热词
    var hotKeyWord = {
        "code": 0,
        "data": [
            {
                "query": "prefab house",
                "impression": 14940,
                "clickRate": 0.048,
                "statDate": "2019-03-23"
            },
            {
                "query": "container house",
                "impression": 1978,
                "clickRate": 0.101,
                "statDate": "2019-03-23"
            },
            {
                "query": "casas prefabricadas",
                "impression": 1185,
                "clickRate": 0.028,
                "statDate": "2019-03-23"
            },
            {
                "query": "prefabricated houses",
                "impression": 1108,
                "clickRate": 0.03,
                "statDate": "2019-03-23"
            },
            {
                "query": "modern prefab house",
                "impression": 788,
                "clickRate": 0.028,
                "statDate": "2019-03-23"
            },
            {
                "query": "container",
                "impression": 703,
                "clickRate": 0.04,
                "statDate": "2019-03-23"
            },
            {
                "query": "prefab homes",
                "impression": 700,
                "clickRate": 0.033,
                "statDate": "2019-03-23"
            },
            {
                "query": "home",
                "impression": 684,
                "clickRate": 0.038,
                "statDate": "2019-03-23"
            },
            {
                "query": "container homes",
                "impression": 537,
                "clickRate": 0.074,
                "statDate": "2019-03-23"
            },
            {
                "query": "tiny house",
                "impression": 482,
                "clickRate": 0.015,
                "statDate": "2019-03-23"
            }
        ],
        "message": "操作成功",
        "traceId": "0bb3d9a015536695633343796e4c6a"
    };

    // 店铺热品
    var topProduct = {
        "successed": true,
        "value": [
            {
                "id": 62030614372,
                "editURL": "http://hz-productposting.alibaba.com/product/edit_product.htm?id=62030614372",
                "isDisplay": true,
                "subject": "Good buy container house Solar energy 40ft high cube container house for sale Green flat pack container house in south africa",
                "sumProdFbNum": 1,
                "detailURL": "http://www.alibaba.com/product-detail/Good-buy-container-house-Solar-energy_62030614372.html",
                "sumProdVisitorCnt": 63,
                "imageURL": "Good-buy-container-house-Solar-energy-40ft.jpg_100x100.jpg"
            },
            {
                "id": 60669511193,
                "editURL": "http://hz-productposting.alibaba.com/product/edit_product.htm?id=60669511193",
                "isDisplay": true,
                "subject": "wholesale cheap portable houses japan prefab house fast building prefab homes for fiji solar power container home",
                "sumProdFbNum": 1,
                "detailURL": "http://www.alibaba.com/product-detail/wholesale-cheap-portable-houses-japan-prefab_60669511193.html",
                "sumProdVisitorCnt": 53,
                "imageURL": "wholesale-cheap-portable-houses-japan-prefab-house.jpg_100x100.jpg"
            },
            {
                "id": 60678981347,
                "editURL": "http://hz-productposting.alibaba.com/product/edit_product.htm?id=60678981347",
                "isDisplay": true,
                "subject": "South America shipping flat pack container beach house america container house",
                "sumProdFbNum": 1,
                "detailURL": "http://www.alibaba.com/product-detail/South-America-shipping-flat-pack-container_60678981347.html",
                "sumProdVisitorCnt": 50,
                "imageURL": "South-America-shipping-flat-pack-container-beach.jpg_100x100.jpg"
            },
            {
                "id": 60777081641,
                "editURL": "http://hz-productposting.alibaba.com/product/edit_product.htm?id=60777081641",
                "isDisplay": true,
                "subject": "Dream House Shipping Portable Container Store 40ft Expandable Modular Homes",
                "sumProdFbNum": 0,
                "detailURL": "http://www.alibaba.com/product-detail/Dream-House-Shipping-Portable-Container-Store_60777081641.html",
                "sumProdVisitorCnt": 32,
                "imageURL": "Dream-House-Shipping-Portable-Container-Store-40ft.jpg_100x100.jpg"
            },
            {
                "id": 60698127243,
                "editURL": "http://hz-productposting.alibaba.com/product/edit_product.htm?id=60698127243",
                "isDisplay": true,
                "subject": "Cheap Mobile Homes Prefab House Modern Summer House Wholesale Ready Made House",
                "sumProdFbNum": 1,
                "detailURL": "http://www.alibaba.com/product-detail/Cheap-Mobile-Homes-Prefab-House-Modern_60698127243.html",
                "sumProdVisitorCnt": 24,
                "imageURL": "Cheap-Mobile-Homes-Prefab-House-Modern-Summer.jpeg_100x100.jpeg"
            }
        ]
    };

    // 实时 - 今日店铺访问人数折线图
    var realTimeShopVisitorTrend = {
        "code": 0,
        "data": [
            {
                "statHour": 0,
                "shopUv": 17,
                "shopUvWsPercent": 0.8235294118
            },
            {
                "statHour": 1,
                "shopUv": 47,
                "shopUvWsPercent": 0.7659574468
            },
            {
                "statHour": 2,
                "shopUv": 57,
                "shopUvWsPercent": 0.7017543860
            },
            {
                "statHour": 3,
                "shopUv": 72,
                "shopUvWsPercent": 0.6944444444
            },
            {
                "statHour": 4,
                "shopUv": 84,
                "shopUvWsPercent": 0.6666666667
            },
            {
                "statHour": 5,
                "shopUv": 94,
                "shopUvWsPercent": 0.6808510638
            },
            {
                "statHour": 6,
                "shopUv": 104,
                "shopUvWsPercent": 0.6538461538
            },
            {
                "statHour": 7,
                "shopUv": 138,
                "shopUvWsPercent": 0.6594202899
            },
            {
                "statHour": 8,
                "shopUv": 157,
                "shopUvWsPercent": 0.6624203822
            },
            {
                "statHour": 9,
                "shopUv": 172,
                "shopUvWsPercent": 0.6744186047
            },
            {
                "statHour": 10,
                "shopUv": 190,
                "shopUvWsPercent": 0.7000000000
            },
            {
                "statHour": 11,
                "shopUv": 217,
                "shopUvWsPercent": 0.7188940092
            },
            {
                "statHour": 12,
                "shopUv": 237,
                "shopUvWsPercent": 0.7215189873
            },
            {
                "statHour": 13,
                "shopUv": 258,
                "shopUvWsPercent": 0.7364341085
            },
            {
                "statHour": 14,
                "shopUv": 278,
                "shopUvWsPercent": 0.7374100719
            },
            {
                "statHour": 15,
                "shopUv": 300,
                "shopUvWsPercent": 0.7333333333
            },
            {
                "statHour": 16,
                "shopUv": 303,
                "shopUvWsPercent": 0.7359735974
            },
            {
                "statHour": 17,
                "shopUv": 314,
                "shopUvWsPercent": 0.7388535032
            },
            {
                "statHour": 18,
                "shopUv": 326,
                "shopUvWsPercent": 0.7453987730
            },
            {
                "statHour": 19,
                "shopUv": 347,
                "shopUvWsPercent": 0.7492795389
            },
            {
                "statHour": 20,
                "shopUv": 367,
                "shopUvWsPercent": 0.7547683924
            },
            {
                "statHour": 21,
                "shopUv": 382,
                "shopUvWsPercent": 0.7565445026
            },
            {
                "statHour": 22,
                "shopUv": 395,
                "shopUvWsPercent": 0.7569620253
            },
            {
                "statHour": 23,
                "shopUv": 403,
                "shopUvWsPercent": 0.7593052109
            }
        ],
        "message": "操作成功",
        "traceId": "0bb3d95715536679216937194eb0d9"
    };

    // 实时 - 昨日店铺访问人数折线图
    var previousShopVisitorTrend = {
        "code": 0,
        "data": [
            {
                "statHour": 0,
                "shopUv": 21,
                "shopUvWsPercent": 0.7619047619
            },
            {
                "statHour": 1,
                "shopUv": 38,
                "shopUvWsPercent": 0.7894736842
            },
            {
                "statHour": 2,
                "shopUv": 58,
                "shopUvWsPercent": 0.8103448276
            },
            {
                "statHour": 3,
                "shopUv": 79,
                "shopUvWsPercent": 0.8227848101
            },
            {
                "statHour": 4,
                "shopUv": 109,
                "shopUvWsPercent": 0.8165137615
            },
            {
                "statHour": 5,
                "shopUv": 135,
                "shopUvWsPercent": 0.8222222222
            },
            {
                "statHour": 6,
                "shopUv": 168,
                "shopUvWsPercent": 0.8452380952
            },
            {
                "statHour": 7,
                "shopUv": 207,
                "shopUvWsPercent": 0.8502415459
            },
            {
                "statHour": 8,
                "shopUv": 248,
                "shopUvWsPercent": 0.8145161290
            },
            {
                "statHour": 9,
                "shopUv": 269,
                "shopUvWsPercent": 0.8215613383
            },
            {
                "statHour": 10,
                "shopUv": 290,
                "shopUvWsPercent": 0.8206896552
            },
            {
                "statHour": 11,
                "shopUv": 316,
                "shopUvWsPercent": 0.8227848101
            },
            {
                "statHour": 12,
                "shopUv": 356,
                "shopUvWsPercent": 0.8286516854
            },
            {
                "statHour": 13,
                "shopUv": 387,
                "shopUvWsPercent": 0.8165374677
            },
            {
                "statHour": 14,
                "shopUv": 428,
                "shopUvWsPercent": 0.8060747664
            },
            {
                "statHour": 15,
                "shopUv": 452,
                "shopUvWsPercent": 0.7942477876
            },
            {
                "statHour": 16,
                "shopUv": 464,
                "shopUvWsPercent": 0.7909482759
            },
            {
                "statHour": 17,
                "shopUv": 484,
                "shopUvWsPercent": 0.7954545455
            },
            {
                "statHour": 18,
                "shopUv": 498,
                "shopUvWsPercent": 0.7931726908
            },
            {
                "statHour": 19,
                "shopUv": 514,
                "shopUvWsPercent": 0.7840466926
            },
            {
                "statHour": 20,
                "shopUv": 527,
                "shopUvWsPercent": 0.7836812144
            },
            {
                "statHour": 21,
                "shopUv": 548,
                "shopUvWsPercent": 0.7791970803
            },
            {
                "statHour": 22,
                "shopUv": 560,
                "shopUvWsPercent": 0.7750000000
            },
            {
                "statHour": 23,
                "shopUv": 570,
                "shopUvWsPercent": 0.7754385965
            }
        ],
        "message": "操作成功",
        "traceId": "0bb7252115535945422606195ec0c1"
    };

    // 实时 - 其他数据
    var realTimeShopStats = {
        "code": 0,
        "data": {
            "fbPv": {// 询盘个数
                "wsPercent": 0.8750000000,//无线占比
                "value": 8,
                "cycleCrc": -0.5294117647//较昨日
            },
            "shopUv": {// 店铺访问人数
                "wsPercent": 0.7599009901,
                "value": 204,
                "cycleCrc": -0.2912280702
            },
            "shopPv": {// 店铺访问次数
                "wsPercent": 0.7676056338,
                "value": 710,
                "cycleCrc": -0.3660714286
            },
            "statDate": {
                "value": "2019-03-26"
            }
        },
        "message": "操作成功",
        "traceId": "0bb3d94915536681540782943eb6c9"
    };

    // 标杆行业
    var industries = {
        "successed": true,
        "value": [
            {
                "rank": 4,
                "parentIndustryDesc": "Building Boards",
                "industryDesc": "Sandwich Panels",
                "industryId": 100007096,
                "parentIndustryId": 100005320
            },
            {
                "rank": 3,
                "parentIndustryDesc": "Bathroom & Kitchen",
                "industryDesc": "Toilet & Accessories",
                "industryId": 127726083,
                "parentIndustryId": 100006265
            },
            {
                "rank": 2,
                "parentIndustryDesc": "Steel",
                "industryDesc": "Steel Structures",
                "industryId": 933,
                "parentIndustryId": 100000317
            },
            {
                "rank": 1,
                "parentIndustryDesc": "Real Estate",
                "industryDesc": "Prefab Houses",
                "industryId": 3113,
                "parentIndustryId": 31
            }
        ]
    };

    // 经营数据（表格、头部）
    var shopSummary = {
        "code": 0,
        "data": [
            {
                "natureExposureCnt": {
                    "rivalAvg": 917.6,
                    "value": 6780,
                    "cycleCrc": null,
                    "rivalGood": 4292.0
                },
                "fbPv": {//询盘个数
                    "rivalAvg": 1.7,//行业平均
                    "value": 17,//当前值
                    "cycleCrc": 0.1333333333,//较上周
                    "rivalGood": 9.0//同行优秀
                },
                "searchClicks": {//搜索点击次数
                    "rivalAvg": 18.4,
                    "value": 251,
                    "cycleCrc": -0.5549645390,
                    "rivalGood": 106.0
                },
                "p4pExposureCnt": {
                    "rivalAvg": 647.0,
                    "value": 2157,
                    "cycleCrc": -0.2361898017,
                    "rivalGood": 2817.0
                },
                "shopPv": {//店铺访问次数
                    "rivalAvg": 125.1,
                    "value": 1082,
                    "cycleCrc": -0.2609289617,
                    "rivalGood": 1321.0
                },
                "statDate": {
                    "value": "2019-03-25"
                },
                "orderCount": {// 信保交易订单个数
                    "rivalAvg": 0.0,
                    "value": 0,
                    "cycleCrc": null,
                    "rivalGood": 0.0
                },
                "orderAmount": {//信保交易金额(美元)
                    "rivalAvg": 0.5,
                    "value": 0,
                    "cycleCrc": null,
                    "rivalGood": 0.0
                },
                "p4pClickCnt": {
                    "rivalAvg": 5.6,
                    "value": 39,
                    "cycleCrc": -0.3157894737,
                    "rivalGood": 30.0
                },
                "natureClickCnt": {
                    "rivalAvg": 12.8,
                    "value": 212,
                    "cycleCrc": null,
                    "rivalGood": 83.0
                },
                "statDateRange": "2019-03-25",
                "shopUv": {//店铺访问人数
                    "rivalAvg": 75.3,
                    "value": 564,
                    "cycleCrc": -0.3325443787,
                    "rivalGood": 812.0
                },
                "tmUv": {//TM咨询人数
                    "rivalAvg": 1.5,
                    "value": 8,
                    "cycleCrc": 0.3333333333,
                    "rivalGood": 9.0
                },
                "searchImps": {//搜索曝光次数
                    "rivalAvg": 1564.6,
                    "value": 8937,
                    "cycleCrc": -0.3920408163,
                    "rivalGood": 5834.0
                },
                "fbUv": {//询盘人数
                    "rivalAvg": 1.4,
                    "value": 15,
                    "cycleCrc": 0.1538461538,
                    "rivalGood": 7.0
                }
            },
            {
                "natureExposureCnt": {
                    "value": 0,
                    "cycleCrc": null
                },
                "fbPv": {
                    "rivalAvg": 1.1,
                    "value": 7,
                    "cycleCrc": -0.2222222222,
                    "rivalGood": 4.0
                },
                "searchClicks": {
                    "rivalAvg": 18.9,
                    "value": 315,
                    "cycleCrc": -0.0816326531,
                    "rivalGood": 89.0
                },
                "p4pExposureCnt": {
                    "rivalAvg": 575.8,
                    "value": 2693,
                    "cycleCrc": 0.2319304666,
                    "rivalGood": 2102.0
                },
                "shopPv": {
                    "rivalAvg": 86.5,
                    "value": 1129,
                    "cycleCrc": 0.2699662542,
                    "rivalGood": 644.0
                },
                "statDate": {
                    "value": "2019-03-24"
                },
                "orderCount": {
                    "rivalAvg": 0.1,
                    "value": 0,
                    "cycleCrc": null,
                    "rivalGood": 1.0
                },
                "orderAmount": {
                    "rivalAvg": 222.5,
                    "value": 0,
                    "cycleCrc": null,
                    "rivalGood": 3471.0
                },
                "p4pClickCnt": {
                    "rivalAvg": 5.2,
                    "value": 60,
                    "cycleCrc": 0.0526315789,
                    "rivalGood": 29.0
                },
                "natureClickCnt": {
                    "value": 0,
                    "cycleCrc": null
                },
                "statDateRange": "2019-03-24",
                "shopUv": {
                    "rivalAvg": 48.6,
                    "value": 605,
                    "cycleCrc": 0.1590038314,
                    "rivalGood": 375.0
                },
                "tmUv": {
                    "rivalAvg": 0.8,
                    "value": 5,
                    "cycleCrc": -0.4444444444,
                    "rivalGood": 4.0
                },
                "searchImps": {
                    "rivalAvg": 1447.9,
                    "value": 9451,
                    "cycleCrc": -0.1144115442,
                    "rivalGood": 4950.0
                },
                "fbUv": {
                    "rivalAvg": 0.9,
                    "value": 5,
                    "cycleCrc": -0.4444444444,
                    "rivalGood": 4.0
                }
            }
        ],
        "message": "操作成功",
        "traceId": "0b09865515536722131171464e973c"
    };

    // 经营数据折线图
    var shopTrends = {
        "code": 0,
        "data": [
            {
                "shopUvRivalAvg": 75.3,//店铺访问人数-行业平均
                "natureSearchClicks": 212,
                "natureExposureCnt": 6780,
                "natureSearchClicksRivalAvg": 12.799999999999999,
                "searchClicksRivalAvg": 18.4,//搜索点击次数-行业平均
                "orderAmountRivalAvg": 0.5,//信保订单交易金额-行业平均
                "fbUvRivalAvg": 1.4,//询盘人数-行业平均
                "p4pExposureCnt": 2157,
                "natureClickCntRivalGood": 83.0,
                "natureSearchImpsRivalGood": 3017.0,
                "natureSearchImpsRivalAvg": 917.5999999999999,
                "p4pExposureCntRivalGood": 2817.0,
                "natureExposureCntRivalAvg": 917.6,
                "orderCountRivalAvg": 0.0,//信保订单交易个数-行业平均
                "orderCount": 0,//信保订单交易个数-我的效果
                "shopPvRivalGood": 1321.0,//店铺访问次数-同行优秀
                "orderAmount": 0,//信保订单交易金额-我的效果
                "p4pClickCnt": 39,
                "orderCountRivalGood": 0.0,//信保订单交易个数-同行优秀
                "tmUvRivalAvg": 1.5,//tm咨询人数-行业平均
                "fbPvRivalGood": 9.0,//询盘个数-同行优秀
                "statDateRange": "2019-03-25",
                "shopUv": 564,//店铺访问人数-我的效果
                "p4pClickCntRivalGood": 30.0,
                "searchImpsRivalGood": 5834.0,//搜索曝光次数-同行优秀
                "fbUv": 15,//询盘人数-我的效果
                "fbUvRivalGood": 7.0,//询盘人数-同行优秀
                "fbPvRivalAvg": 1.7,//询盘个数-行业平均
                "natureSearchImps": 6780,
                "searchClicks": 251,//搜索点击次数-我的效果
                "shopPvRivalAvg": 125.1,//店铺访问次数-行业平均
                "fbPv": 17,//询盘个数-我的效果
                "natureExposureCntRivalGood": 4292.0,
                "p4pClickCntRivalAvg": 5.6,
                "natureClickCntRivalAvg": 12.8,
                "p4pExposureCntRivalAvg": 647.0,
                "shopPv": 1082,//店铺访问次数-我的效果
                "searchImpsRivalAvg": 1564.6,//搜索曝光次数-行业平均
                "shopUvRivalGood": 812.0,//店铺访问人数-同行优秀
                "statDate": "2019-03-25",
                "tmUvRivalGood": 9.0,//tm咨询人数-同行优秀
                "natureSearchClicksRivalGood": 76.0,
                "searchClicksRivalGood": 106.0,//搜索点击次数-同行优秀
                "natureClickCnt": 212,
                "tmUv": 8,//tm咨询人数-我的效果
                "orderAmountRivalGood": 0.0,//信保订单交易金额-同行优秀
                "searchImps": 8937//搜索曝光次数-我的效果
            },
            {
                "shopUvRivalAvg": 48.6,
                "natureSearchClicks": 255,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 13.7,
                "orderAmountRivalAvg": 222.5,
                "searchClicksRivalAvg": 18.9,
                "fbUvRivalAvg": 0.9,
                "p4pExposureCnt": 2693,
                "natureSearchImpsRivalGood": 2848.0,
                "natureSearchImpsRivalAvg": 872.1000000000001,
                "p4pExposureCntRivalGood": 2102.0,
                "orderCountRivalAvg": 0.1,
                "orderCount": 0,
                "shopPvRivalGood": 644.0,
                "orderAmount": 0,
                "p4pClickCnt": 60,
                "orderCountRivalGood": 1.0,
                "tmUvRivalAvg": 0.8,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-24",
                "shopUv": 605,
                "p4pClickCntRivalGood": 29.0,
                "searchImpsRivalGood": 4950.0,
                "fbUv": 5,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.1,
                "natureSearchImps": 6758,
                "fbPv": 7,
                "shopPvRivalAvg": 86.5,
                "searchClicks": 315,
                "p4pClickCntRivalAvg": 5.2,
                "p4pExposureCntRivalAvg": 575.8,
                "shopPv": 1129,
                "searchImpsRivalAvg": 1447.9,
                "shopUvRivalGood": 375.0,
                "statDate": "2019-03-24",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 60.0,
                "searchClicksRivalGood": 89.0,
                "natureClickCnt": 0,
                "tmUv": 5,
                "orderAmountRivalGood": 3471.0,
                "searchImps": 9451
            },
            {
                "shopUvRivalAvg": 46.4,
                "natureSearchClicks": 221,
                "natureExposureCnt": 5703,
                "natureSearchClicksRivalAvg": 12.599999999999998,
                "searchClicksRivalAvg": 17.4,
                "orderAmountRivalAvg": 0.6,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2261,
                "natureClickCntRivalGood": 63.0,
                "natureSearchImpsRivalGood": 2491.0,
                "natureSearchImpsRivalAvg": 752.0999999999999,
                "p4pExposureCntRivalGood": 2378.0,
                "natureExposureCntRivalAvg": 752.1,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 658.0,
                "orderAmount": 0,
                "p4pClickCnt": 51,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.5,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-23",
                "shopUv": 543,
                "p4pClickCntRivalGood": 24.0,
                "searchImpsRivalGood": 4869.0,
                "fbUv": 10,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 5703,
                "searchClicks": 272,
                "shopPvRivalAvg": 78.2,
                "fbPv": 13,
                "natureExposureCntRivalGood": 3379.0,
                "p4pClickCntRivalAvg": 4.8,
                "natureClickCntRivalAvg": 12.5,
                "p4pExposureCntRivalAvg": 587.5,
                "shopPv": 1035,
                "searchImpsRivalAvg": 1339.6,
                "shopUvRivalGood": 395.0,
                "statDate": "2019-03-23",
                "tmUvRivalGood": 3.0,
                "natureSearchClicksRivalGood": 56.0,
                "searchClicksRivalGood": 80.0,
                "natureClickCnt": 221,
                "tmUv": 6,
                "orderAmountRivalGood": 9.0,
                "searchImps": 7964
            },
            {
                "shopUvRivalAvg": 47.9,
                "natureSearchClicks": 199,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 12.0,
                "orderAmountRivalAvg": 909.6,
                "searchClicksRivalAvg": 17.0,
                "fbUvRivalAvg": 0.8,
                "p4pExposureCnt": 2774,
                "natureSearchImpsRivalGood": 2577.0,
                "natureSearchImpsRivalAvg": 795.8,
                "p4pExposureCntRivalGood": 2060.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 752.0,
                "orderAmount": 0,
                "p4pClickCnt": 53,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.3,
                "fbPvRivalGood": 9.0,
                "statDateRange": "2019-03-22",
                "shopUv": 496,
                "p4pClickCntRivalGood": 25.0,
                "searchImpsRivalGood": 4637.0,
                "fbUv": 7,
                "fbUvRivalGood": 7.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 5458,
                "fbPv": 7,
                "shopPvRivalAvg": 80.5,
                "searchClicks": 252,
                "p4pClickCntRivalAvg": 5.0,
                "p4pExposureCntRivalAvg": 722.8,
                "shopPv": 804,
                "searchImpsRivalAvg": 1518.6,
                "shopUvRivalGood": 433.0,
                "statDate": "2019-03-22",
                "tmUvRivalGood": 6.0,
                "natureSearchClicksRivalGood": 56.0,
                "searchClicksRivalGood": 81.0,
                "natureClickCnt": 0,
                "tmUv": 6,
                "orderAmountRivalGood": 14008.0,
                "searchImps": 8232
            },
            {
                "shopUvRivalAvg": 51.6,
                "natureSearchClicks": 376,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 13.4,
                "orderAmountRivalAvg": 0.9,
                "searchClicksRivalAvg": 18.3,
                "fbUvRivalAvg": 1.3,
                "p4pExposureCnt": 1739,
                "natureSearchImpsRivalGood": 2986.0,
                "natureSearchImpsRivalAvg": 897.2,
                "p4pExposureCntRivalGood": 2331.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 827.0,
                "orderAmount": 0,
                "p4pClickCnt": 51,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.2,
                "fbPvRivalGood": 8.0,
                "statDateRange": "2019-03-21",
                "shopUv": 726,
                "p4pClickCntRivalGood": 22.0,
                "searchImpsRivalGood": 5317.0,
                "fbUv": 11,
                "fbUvRivalGood": 8.0,
                "fbPvRivalAvg": 1.5,
                "natureSearchImps": 8405,
                "fbPv": 12,
                "shopPvRivalAvg": 90.9,
                "searchClicks": 427,
                "p4pClickCntRivalAvg": 4.9,
                "p4pExposureCntRivalAvg": 666.8,
                "shopPv": 1317,
                "searchImpsRivalAvg": 1564.0,
                "shopUvRivalGood": 452.0,
                "statDate": "2019-03-21",
                "tmUvRivalGood": 6.0,
                "natureSearchClicksRivalGood": 62.0,
                "searchClicksRivalGood": 84.0,
                "natureClickCnt": 0,
                "tmUv": 6,
                "orderAmountRivalGood": 14.0,
                "searchImps": 10144
            },
            {
                "shopUvRivalAvg": 43.9,
                "natureSearchClicks": 399,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 14.5,
                "orderAmountRivalAvg": 277.8,
                "searchClicksRivalAvg": 19.5,
                "fbUvRivalAvg": 1.1,
                "p4pExposureCnt": 2322,
                "natureSearchImpsRivalGood": 2772.0,
                "natureSearchImpsRivalAvg": 941.5999999999999,
                "p4pExposureCntRivalGood": 2576.0,
                "orderCountRivalAvg": 0.1,
                "orderCount": 0,
                "shopPvRivalGood": 551.0,
                "orderAmount": 0,
                "p4pClickCnt": 44,
                "orderCountRivalGood": 1.0,
                "tmUvRivalAvg": 1.4,
                "fbPvRivalGood": 6.0,
                "statDateRange": "2019-03-20",
                "shopUv": 753,
                "p4pClickCntRivalGood": 26.0,
                "searchImpsRivalGood": 5348.0,
                "fbUv": 7,
                "fbUvRivalGood": 6.0,
                "fbPvRivalAvg": 1.2,
                "natureSearchImps": 9464,
                "fbPv": 8,
                "shopPvRivalAvg": 71.8,
                "searchClicks": 443,
                "p4pClickCntRivalAvg": 5.0,
                "p4pExposureCntRivalAvg": 675.2,
                "shopPv": 1328,
                "searchImpsRivalAvg": 1616.8,
                "shopUvRivalGood": 330.0,
                "statDate": "2019-03-20",
                "tmUvRivalGood": 5.0,
                "natureSearchClicksRivalGood": 73.0,
                "searchClicksRivalGood": 99.0,
                "natureClickCnt": 0,
                "tmUv": 7,
                "orderAmountRivalGood": 4212.0,
                "searchImps": 11786
            },
            {
                "shopUvRivalAvg": 47.0,
                "natureSearchClicks": 261,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 14.700000000000001,
                "orderAmountRivalAvg": 173.5,
                "searchClicksRivalAvg": 20.1,
                "fbUvRivalAvg": 1.3,
                "p4pExposureCnt": 1839,
                "natureSearchImpsRivalGood": 3698.0,
                "natureSearchImpsRivalAvg": 1024.9,
                "p4pExposureCntRivalGood": 3301.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 578.0,
                "orderAmount": 0,
                "p4pClickCnt": 50,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.3,
                "fbPvRivalGood": 7.0,
                "statDateRange": "2019-03-19",
                "shopUv": 637,
                "p4pClickCntRivalGood": 24.0,
                "searchImpsRivalGood": 6999.0,
                "fbUv": 9,
                "fbUvRivalGood": 5.0,
                "fbPvRivalAvg": 1.5,
                "natureSearchImps": 8427,
                "fbPv": 9,
                "shopPvRivalAvg": 77.8,
                "searchClicks": 311,
                "p4pClickCntRivalAvg": 5.4,
                "p4pExposureCntRivalAvg": 689.4,
                "shopPv": 1082,
                "searchImpsRivalAvg": 1714.3,
                "shopUvRivalGood": 354.0,
                "statDate": "2019-03-19",
                "tmUvRivalGood": 8.0,
                "natureSearchClicksRivalGood": 63.0,
                "searchClicksRivalGood": 87.0,
                "natureClickCnt": 0,
                "tmUv": 3,
                "orderAmountRivalGood": 2602.0,
                "searchImps": 10266
            },
            {
                "shopUvRivalAvg": 58.1,
                "natureSearchClicks": 507,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 14.100000000000001,
                "orderAmountRivalAvg": 84.5,
                "searchClicksRivalAvg": 19.1,
                "fbUvRivalAvg": 1.4,
                "p4pExposureCnt": 2824,
                "natureSearchImpsRivalGood": 4075.0,
                "natureSearchImpsRivalAvg": 1014.0,
                "p4pExposureCntRivalGood": 1707.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 926.0,
                "orderAmount": 0,
                "p4pClickCnt": 57,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.2,
                "fbPvRivalGood": 9.0,
                "statDateRange": "2019-03-18",
                "shopUv": 845,
                "p4pClickCntRivalGood": 17.0,
                "searchImpsRivalGood": 5782.0,
                "fbUv": 13,
                "fbUvRivalGood": 8.0,
                "fbPvRivalAvg": 1.6,
                "natureSearchImps": 11876,
                "fbPv": 15,
                "shopPvRivalAvg": 102.4,
                "searchClicks": 564,
                "p4pClickCntRivalAvg": 5.0,
                "p4pExposureCntRivalAvg": 573.3,
                "shopPv": 1464,
                "searchImpsRivalAvg": 1587.3,
                "shopUvRivalGood": 526.0,
                "statDate": "2019-03-18",
                "tmUvRivalGood": 8.0,
                "natureSearchClicksRivalGood": 74.0,
                "searchClicksRivalGood": 91.0,
                "natureClickCnt": 0,
                "tmUv": 6,
                "orderAmountRivalGood": 0.0,
                "searchImps": 14700
            },
            {
                "shopUvRivalAvg": 43.9,
                "natureSearchClicks": 286,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 13.700000000000001,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 18.3,
                "fbUvRivalAvg": 1.0,
                "p4pExposureCnt": 2186,
                "natureSearchImpsRivalGood": 3079.0,
                "natureSearchImpsRivalAvg": 897.4,
                "p4pExposureCntRivalGood": 1610.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 538.0,
                "orderAmount": 0,
                "p4pClickCnt": 57,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.0,
                "fbPvRivalGood": 7.0,
                "statDateRange": "2019-03-17",
                "shopUv": 522,
                "p4pClickCntRivalGood": 17.0,
                "searchImpsRivalGood": 4689.0,
                "fbUv": 9,
                "fbUvRivalGood": 6.0,
                "fbPvRivalAvg": 1.2,
                "natureSearchImps": 8486,
                "fbPv": 9,
                "shopPvRivalAvg": 72.4,
                "searchClicks": 343,
                "p4pClickCntRivalAvg": 4.6,
                "p4pExposureCntRivalAvg": 468.4,
                "shopPv": 889,
                "searchImpsRivalAvg": 1365.8,
                "shopUvRivalGood": 322.0,
                "statDate": "2019-03-17",
                "tmUvRivalGood": 7.0,
                "natureSearchClicksRivalGood": 70.0,
                "searchClicksRivalGood": 87.0,
                "natureClickCnt": 0,
                "tmUv": 9,
                "orderAmountRivalGood": 0.0,
                "searchImps": 10672
            },
            {
                "shopUvRivalAvg": 26.1,
                "natureSearchClicks": 268,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.5,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 13.4,
                "fbUvRivalAvg": 0.5,
                "p4pExposureCnt": 2858,
                "natureSearchImpsRivalGood": 2182.0,
                "natureSearchImpsRivalAvg": 650.8,
                "p4pExposureCntRivalGood": 1269.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 201.0,
                "orderAmount": 0,
                "p4pClickCnt": 55,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.4,
                "fbPvRivalGood": 2.0,
                "statDateRange": "2019-03-16",
                "shopUv": 480,
                "p4pClickCntRivalGood": 11.0,
                "searchImpsRivalGood": 3451.0,
                "fbUv": 10,
                "fbUvRivalGood": 2.0,
                "fbPvRivalAvg": 0.5,
                "natureSearchImps": 7289,
                "fbPv": 11,
                "shopPvRivalAvg": 42.2,
                "searchClicks": 323,
                "p4pClickCntRivalAvg": 3.9,
                "p4pExposureCntRivalAvg": 466.8,
                "shopPv": 824,
                "searchImpsRivalAvg": 1117.6,
                "shopUvRivalGood": 124.0,
                "statDate": "2019-03-16",
                "tmUvRivalGood": 2.0,
                "natureSearchClicksRivalGood": 39.0,
                "searchClicksRivalGood": 50.0,
                "natureClickCnt": 0,
                "tmUv": 1,
                "orderAmountRivalGood": 0.0,
                "searchImps": 10147
            },
            {
                "shopUvRivalAvg": 28.0,
                "natureSearchClicks": 180,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.6,
                "orderAmountRivalAvg": 0.9,
                "searchClicksRivalAvg": 16.0,
                "fbUvRivalAvg": 1.0,
                "p4pExposureCnt": 2325,
                "natureSearchImpsRivalGood": 2200.0,
                "natureSearchImpsRivalAvg": 692.5000000000001,
                "p4pExposureCntRivalGood": 1215.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 230.0,
                "orderAmount": 0,
                "p4pClickCnt": 56,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.9,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-15",
                "shopUv": 410,
                "p4pClickCntRivalGood": 15.0,
                "searchImpsRivalGood": 3415.0,
                "fbUv": 6,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 6458,
                "fbPv": 9,
                "shopPvRivalAvg": 46.7,
                "searchClicks": 236,
                "p4pClickCntRivalAvg": 4.4,
                "p4pExposureCntRivalAvg": 550.4,
                "shopPv": 730,
                "searchImpsRivalAvg": 1242.9,
                "shopUvRivalGood": 139.0,
                "statDate": "2019-03-15",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 50.0,
                "searchClicksRivalGood": 65.0,
                "natureClickCnt": 0,
                "tmUv": 7,
                "orderAmountRivalGood": 13.0,
                "searchImps": 8783
            },
            {
                "shopUvRivalAvg": 30.0,
                "natureSearchClicks": 195,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.200000000000001,
                "orderAmountRivalAvg": 345.4,
                "searchClicksRivalAvg": 16.1,
                "fbUvRivalAvg": 0.9,
                "p4pExposureCnt": 2260,
                "natureSearchImpsRivalGood": 2403.0,
                "natureSearchImpsRivalAvg": 759.6000000000001,
                "p4pExposureCntRivalGood": 1528.0,
                "orderCountRivalAvg": 0.1,
                "orderCount": 0,
                "shopPvRivalGood": 237.0,
                "orderAmount": 0,
                "p4pClickCnt": 53,
                "orderCountRivalGood": 1.0,
                "tmUvRivalAvg": 0.9,
                "fbPvRivalGood": 5.0,
                "statDateRange": "2019-03-14",
                "shopUv": 471,
                "p4pClickCntRivalGood": 13.0,
                "searchImpsRivalGood": 3931.0,
                "fbUv": 6,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 6814,
                "fbPv": 6,
                "shopPvRivalAvg": 49.8,
                "searchClicks": 248,
                "p4pClickCntRivalAvg": 4.9,
                "p4pExposureCntRivalAvg": 538.3,
                "shopPv": 828,
                "searchImpsRivalAvg": 1297.9,
                "shopUvRivalGood": 145.0,
                "statDate": "2019-03-14",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 45.0,
                "searchClicksRivalGood": 58.0,
                "natureClickCnt": 0,
                "tmUv": 6,
                "orderAmountRivalGood": 3912.0,
                "searchImps": 9074
            },
            {
                "shopUvRivalAvg": 31.7,
                "natureSearchClicks": 207,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.1,
                "orderAmountRivalAvg": 79.5,
                "searchClicksRivalAvg": 16.0,
                "fbUvRivalAvg": 0.8,
                "p4pExposureCnt": 2598,
                "natureSearchImpsRivalGood": 2509.0,
                "natureSearchImpsRivalAvg": 784.8,
                "p4pExposureCntRivalGood": 1712.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 262.0,
                "orderAmount": 0,
                "p4pClickCnt": 57,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.1,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-13",
                "shopUv": 485,
                "p4pClickCntRivalGood": 16.0,
                "searchImpsRivalGood": 4221.0,
                "fbUv": 13,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.9,
                "natureSearchImps": 6519,
                "fbPv": 13,
                "shopPvRivalAvg": 51.0,
                "searchClicks": 264,
                "p4pClickCntRivalAvg": 4.9,
                "p4pExposureCntRivalAvg": 641.8,
                "shopPv": 785,
                "searchImpsRivalAvg": 1426.6,
                "shopUvRivalGood": 153.0,
                "statDate": "2019-03-13",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 41.0,
                "searchClicksRivalGood": 57.0,
                "natureClickCnt": 0,
                "tmUv": 5,
                "orderAmountRivalGood": 0.0,
                "searchImps": 9117
            },
            {
                "shopUvRivalAvg": 31.7,
                "natureSearchClicks": 244,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.4,
                "orderAmountRivalAvg": 667.2,
                "searchClicksRivalAvg": 16.8,
                "fbUvRivalAvg": 1.0,
                "p4pExposureCnt": 1880,
                "natureSearchImpsRivalGood": 2499.0,
                "natureSearchImpsRivalAvg": 758.1,
                "p4pExposureCntRivalGood": 1388.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 252.0,
                "orderAmount": 0,
                "p4pClickCnt": 55,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.8,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-12",
                "shopUv": 621,
                "p4pClickCntRivalGood": 18.0,
                "searchImpsRivalGood": 3887.0,
                "fbUv": 11,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 7361,
                "fbPv": 13,
                "shopPvRivalAvg": 52.8,
                "searchClicks": 299,
                "p4pClickCntRivalAvg": 5.4,
                "p4pExposureCntRivalAvg": 625.6,
                "shopPv": 1069,
                "searchImpsRivalAvg": 1383.7,
                "shopUvRivalGood": 160.0,
                "statDate": "2019-03-12",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 48.0,
                "searchClicksRivalGood": 66.0,
                "natureClickCnt": 0,
                "tmUv": 9,
                "orderAmountRivalGood": 10000.0,
                "searchImps": 9241
            },
            {
                "shopUvRivalAvg": 29.9,
                "natureSearchClicks": 278,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 10.5,
                "orderAmountRivalAvg": 649.5,
                "searchClicksRivalAvg": 15.6,
                "fbUvRivalAvg": 0.6,
                "p4pExposureCnt": 3739,
                "natureSearchImpsRivalGood": 2375.0,
                "natureSearchImpsRivalAvg": 770.5999999999999,
                "p4pExposureCntRivalGood": 2020.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 237.0,
                "orderAmount": 0,
                "p4pClickCnt": 53,
                "orderCountRivalGood": 1.0,
                "tmUvRivalAvg": 1.4,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-03-11",
                "shopUv": 656,
                "p4pClickCntRivalGood": 21.0,
                "searchImpsRivalGood": 4395.0,
                "fbUv": 7,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.6,
                "natureSearchImps": 7901,
                "fbPv": 8,
                "shopPvRivalAvg": 50.6,
                "searchClicks": 331,
                "p4pClickCntRivalAvg": 5.1,
                "p4pExposureCntRivalAvg": 634.0,
                "shopPv": 1057,
                "searchImpsRivalAvg": 1404.6,
                "shopUvRivalGood": 134.0,
                "statDate": "2019-03-11",
                "tmUvRivalGood": 6.0,
                "natureSearchClicksRivalGood": 44.0,
                "searchClicksRivalGood": 65.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 9872.0,
                "searchImps": 11640
            },
            {
                "shopUvRivalAvg": 31.6,
                "natureSearchClicks": 259,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 12.100000000000001,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 17.6,
                "fbUvRivalAvg": 0.9,
                "p4pExposureCnt": 2018,
                "natureSearchImpsRivalGood": 2590.0,
                "natureSearchImpsRivalAvg": 762.6999999999999,
                "p4pExposureCntRivalGood": 1551.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 217.0,
                "orderAmount": 0,
                "p4pClickCnt": 59,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.9,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-10",
                "shopUv": 615,
                "p4pClickCntRivalGood": 19.0,
                "searchImpsRivalGood": 4141.0,
                "fbUv": 7,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 7158,
                "fbPv": 9,
                "shopPvRivalAvg": 51.8,
                "searchClicks": 318,
                "p4pClickCntRivalAvg": 5.5,
                "p4pExposureCntRivalAvg": 616.4,
                "shopPv": 1061,
                "searchImpsRivalAvg": 1379.1,
                "shopUvRivalGood": 123.0,
                "statDate": "2019-03-10",
                "tmUvRivalGood": 5.0,
                "natureSearchClicksRivalGood": 47.0,
                "searchClicksRivalGood": 66.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 0.0,
                "searchImps": 9176
            },
            {
                "shopUvRivalAvg": 28.3,
                "natureSearchClicks": 163,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 10.9,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 16.5,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2789,
                "natureSearchImpsRivalGood": 2261.0,
                "natureSearchImpsRivalAvg": 679.1999999999999,
                "p4pExposureCntRivalGood": 1283.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 218.0,
                "orderAmount": 0,
                "p4pClickCnt": 53,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.4,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-09",
                "shopUv": 541,
                "p4pClickCntRivalGood": 19.0,
                "searchImpsRivalGood": 3544.0,
                "fbUv": 5,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 6188,
                "fbPv": 6,
                "shopPvRivalAvg": 47.8,
                "searchClicks": 216,
                "p4pClickCntRivalAvg": 5.6,
                "p4pExposureCntRivalAvg": 662.9,
                "shopPv": 925,
                "searchImpsRivalAvg": 1342.1,
                "shopUvRivalGood": 131.0,
                "statDate": "2019-03-09",
                "tmUvRivalGood": 2.0,
                "natureSearchClicksRivalGood": 44.0,
                "searchClicksRivalGood": 63.0,
                "natureClickCnt": 0,
                "tmUv": 1,
                "orderAmountRivalGood": 0.0,
                "searchImps": 8977
            },
            {
                "shopUvRivalAvg": 25.0,
                "natureSearchClicks": 194,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.600000000000001,
                "orderAmountRivalAvg": 3.6,
                "searchClicksRivalAvg": 14.3,
                "fbUvRivalAvg": 0.8,
                "p4pExposureCnt": 1811,
                "natureSearchImpsRivalGood": 2088.0,
                "natureSearchImpsRivalAvg": 656.9000000000001,
                "p4pExposureCntRivalGood": 1285.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 1,
                "shopPvRivalGood": 218.0,
                "orderAmount": 7695,
                "p4pClickCnt": 50,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.8,
                "fbPvRivalGood": 5.0,
                "statDateRange": "2019-03-08",
                "shopUv": 486,
                "p4pClickCntRivalGood": 14.0,
                "searchImpsRivalGood": 3373.0,
                "fbUv": 3,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 5807,
                "fbPv": 3,
                "shopPvRivalAvg": 42.3,
                "searchClicks": 244,
                "p4pClickCntRivalAvg": 4.7,
                "p4pExposureCntRivalAvg": 569.8,
                "shopPv": 809,
                "searchImpsRivalAvg": 1226.7,
                "shopUvRivalGood": 120.0,
                "statDate": "2019-03-08",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 40.0,
                "searchClicksRivalGood": 54.0,
                "natureClickCnt": 0,
                "tmUv": 2,
                "orderAmountRivalGood": 12.0,
                "searchImps": 7618
            },
            {
                "shopUvRivalAvg": 28.8,
                "natureSearchClicks": 409,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.200000000000001,
                "orderAmountRivalAvg": 437.5,
                "searchClicksRivalAvg": 16.6,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2220,
                "natureSearchImpsRivalGood": 2597.0,
                "natureSearchImpsRivalAvg": 761.8,
                "p4pExposureCntRivalGood": 1438.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 233.0,
                "orderAmount": 0,
                "p4pClickCnt": 49,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.2,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-03-07",
                "shopUv": 764,
                "p4pClickCntRivalGood": 17.0,
                "searchImpsRivalGood": 4035.0,
                "fbUv": 11,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 10743,
                "fbPv": 11,
                "shopPvRivalAvg": 47.5,
                "searchClicks": 458,
                "p4pClickCntRivalAvg": 5.4,
                "p4pExposureCntRivalAvg": 621.5,
                "shopPv": 1397,
                "searchImpsRivalAvg": 1383.3,
                "shopUvRivalGood": 139.0,
                "statDate": "2019-03-07",
                "tmUvRivalGood": 5.0,
                "natureSearchClicksRivalGood": 49.0,
                "searchClicksRivalGood": 66.0,
                "natureClickCnt": 0,
                "tmUv": 3,
                "orderAmountRivalGood": 83.0,
                "searchImps": 12963
            },
            {
                "shopUvRivalAvg": 33.5,
                "natureSearchClicks": 676,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 12.5,
                "orderAmountRivalAvg": 293.0,
                "searchClicksRivalAvg": 17.8,
                "fbUvRivalAvg": 1.0,
                "p4pExposureCnt": 2813,
                "natureSearchImpsRivalGood": 3037.0,
                "natureSearchImpsRivalAvg": 851.1,
                "p4pExposureCntRivalGood": 1594.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 340.0,
                "orderAmount": 0,
                "p4pClickCnt": 44,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.9,
                "fbPvRivalGood": 6.0,
                "statDateRange": "2019-03-06",
                "shopUv": 1172,
                "p4pClickCntRivalGood": 19.0,
                "searchImpsRivalGood": 4631.0,
                "fbUv": 11,
                "fbUvRivalGood": 5.0,
                "fbPvRivalAvg": 1.2,
                "natureSearchImps": 15125,
                "fbPv": 15,
                "shopPvRivalAvg": 57.1,
                "searchClicks": 720,
                "p4pClickCntRivalAvg": 5.3,
                "p4pExposureCntRivalAvg": 585.1,
                "shopPv": 1905,
                "searchImpsRivalAvg": 1436.2,
                "shopUvRivalGood": 185.0,
                "statDate": "2019-03-06",
                "tmUvRivalGood": 6.0,
                "natureSearchClicksRivalGood": 64.0,
                "searchClicksRivalGood": 83.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 3249.0,
                "searchImps": 17938
            },
            {
                "shopUvRivalAvg": 29.4,
                "natureSearchClicks": 345,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 11.500000000000002,
                "orderAmountRivalAvg": 171.1,
                "searchClicksRivalAvg": 16.6,
                "fbUvRivalAvg": 0.9,
                "p4pExposureCnt": 3012,
                "natureSearchImpsRivalGood": 2633.0,
                "natureSearchImpsRivalAvg": 798.5000000000001,
                "p4pExposureCntRivalGood": 2125.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 242.0,
                "orderAmount": 0,
                "p4pClickCnt": 48,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.1,
                "fbPvRivalGood": 6.0,
                "statDateRange": "2019-03-05",
                "shopUv": 782,
                "p4pClickCntRivalGood": 18.0,
                "searchImpsRivalGood": 4758.0,
                "fbUv": 9,
                "fbUvRivalGood": 5.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 8536,
                "fbPv": 11,
                "shopPvRivalAvg": 47.9,
                "searchClicks": 393,
                "p4pClickCntRivalAvg": 5.1,
                "p4pExposureCntRivalAvg": 793.9,
                "shopPv": 1395,
                "searchImpsRivalAvg": 1592.4,
                "shopUvRivalGood": 145.0,
                "statDate": "2019-03-05",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 47.0,
                "searchClicksRivalGood": 65.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 2566.0,
                "searchImps": 11548
            },
            {
                "shopUvRivalAvg": 28.6,
                "natureSearchClicks": 351,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 10.799999999999999,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 16.2,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2437,
                "natureSearchImpsRivalGood": 2576.0,
                "natureSearchImpsRivalAvg": 760.6999999999999,
                "p4pExposureCntRivalGood": 1868.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 230.0,
                "orderAmount": 0,
                "p4pClickCnt": 44,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.5,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-03-04",
                "shopUv": 638,
                "p4pClickCntRivalGood": 17.0,
                "searchImpsRivalGood": 4444.0,
                "fbUv": 9,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 9454,
                "fbPv": 9,
                "shopPvRivalAvg": 50.0,
                "searchClicks": 395,
                "p4pClickCntRivalAvg": 5.4,
                "p4pExposureCntRivalAvg": 687.4,
                "shopPv": 1119,
                "searchImpsRivalAvg": 1448.1,
                "shopUvRivalGood": 128.0,
                "statDate": "2019-03-04",
                "tmUvRivalGood": 7.0,
                "natureSearchClicksRivalGood": 51.0,
                "searchClicksRivalGood": 68.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 0.0,
                "searchImps": 11891
            },
            {
                "shopUvRivalAvg": 30.1,
                "natureSearchClicks": 167,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 12.5,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 17.3,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 3444,
                "natureSearchImpsRivalGood": 2753.0,
                "natureSearchImpsRivalAvg": 806.3999999999999,
                "p4pExposureCntRivalGood": 1441.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 251.0,
                "orderAmount": 0,
                "p4pClickCnt": 44,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.7,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-03-03",
                "shopUv": 363,
                "p4pClickCntRivalGood": 20.0,
                "searchImpsRivalGood": 4194.0,
                "fbUv": 6,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 7186,
                "fbPv": 7,
                "shopPvRivalAvg": 52.7,
                "searchClicks": 211,
                "p4pClickCntRivalAvg": 4.8,
                "p4pExposureCntRivalAvg": 513.7,
                "shopPv": 609,
                "searchImpsRivalAvg": 1320.1,
                "shopUvRivalGood": 134.0,
                "statDate": "2019-03-03",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 52.0,
                "searchClicksRivalGood": 72.0,
                "natureClickCnt": 0,
                "tmUv": 6,
                "orderAmountRivalGood": 0.0,
                "searchImps": 10630
            },
            {
                "shopUvRivalAvg": 24.6,
                "natureSearchClicks": 166,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.9,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 14.0,
                "fbUvRivalAvg": 0.5,
                "p4pExposureCnt": 1700,
                "natureSearchImpsRivalGood": 2187.0,
                "natureSearchImpsRivalAvg": 643.4000000000001,
                "p4pExposureCntRivalGood": 1397.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 198.0,
                "orderAmount": 0,
                "p4pClickCnt": 29,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 0.4,
                "fbPvRivalGood": 2.0,
                "statDateRange": "2019-03-02",
                "shopUv": 343,
                "p4pClickCntRivalGood": 14.0,
                "searchImpsRivalGood": 3584.0,
                "fbUv": 3,
                "fbUvRivalGood": 1.0,
                "fbPvRivalAvg": 0.5,
                "natureSearchImps": 5531,
                "fbPv": 3,
                "shopPvRivalAvg": 42.3,
                "searchClicks": 195,
                "p4pClickCntRivalAvg": 4.1,
                "p4pExposureCntRivalAvg": 450.3,
                "shopPv": 587,
                "searchImpsRivalAvg": 1093.7,
                "shopUvRivalGood": 107.0,
                "statDate": "2019-03-02",
                "tmUvRivalGood": 2.0,
                "natureSearchClicksRivalGood": 36.0,
                "searchClicksRivalGood": 50.0,
                "natureClickCnt": 0,
                "tmUv": 4,
                "orderAmountRivalGood": 0.0,
                "searchImps": 7231
            },
            {
                "shopUvRivalAvg": 22.0,
                "natureSearchClicks": 144,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.2,
                "orderAmountRivalAvg": 0.4,
                "searchClicksRivalAvg": 12.9,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2257,
                "natureSearchImpsRivalGood": 2067.0,
                "natureSearchImpsRivalAvg": 593.2,
                "p4pExposureCntRivalGood": 1032.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 140.0,
                "orderAmount": 0,
                "p4pClickCnt": 34,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.0,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-03-01",
                "shopUv": 342,
                "p4pClickCntRivalGood": 12.0,
                "searchImpsRivalGood": 3099.0,
                "fbUv": 8,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 4691,
                "fbPv": 10,
                "shopPvRivalAvg": 37.3,
                "searchClicks": 178,
                "p4pClickCntRivalAvg": 3.7,
                "p4pExposureCntRivalAvg": 410.2,
                "shopPv": 669,
                "searchImpsRivalAvg": 1003.4,
                "shopUvRivalGood": 87.0,
                "statDate": "2019-03-01",
                "tmUvRivalGood": 3.0,
                "natureSearchClicksRivalGood": 39.0,
                "searchClicksRivalGood": 51.0,
                "natureClickCnt": 0,
                "tmUv": 3,
                "orderAmountRivalGood": 0.0,
                "searchImps": 6948
            },
            {
                "shopUvRivalAvg": 24.0,
                "natureSearchClicks": 133,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.0,
                "orderAmountRivalAvg": 1.2,
                "searchClicksRivalAvg": 12.2,
                "fbUvRivalAvg": 0.9,
                "p4pExposureCnt": 2987,
                "natureSearchImpsRivalGood": 2224.0,
                "natureSearchImpsRivalAvg": 644.8,
                "p4pExposureCntRivalGood": 1150.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 168.0,
                "orderAmount": 0,
                "p4pClickCnt": 35,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.9,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-02-28",
                "shopUv": 456,
                "p4pClickCntRivalGood": 11.0,
                "searchImpsRivalGood": 3374.0,
                "fbUv": 7,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 1.0,
                "natureSearchImps": 4742,
                "fbPv": 7,
                "shopPvRivalAvg": 40.4,
                "searchClicks": 168,
                "p4pClickCntRivalAvg": 3.2,
                "p4pExposureCntRivalAvg": 489.2,
                "shopPv": 749,
                "searchImpsRivalAvg": 1134.0,
                "shopUvRivalGood": 97.0,
                "statDate": "2019-02-28",
                "tmUvRivalGood": 7.0,
                "natureSearchClicksRivalGood": 31.0,
                "searchClicksRivalGood": 42.0,
                "natureClickCnt": 0,
                "tmUv": 5,
                "orderAmountRivalGood": 19.0,
                "searchImps": 7729
            },
            {
                "shopUvRivalAvg": 25.4,
                "natureSearchClicks": 161,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.6,
                "orderAmountRivalAvg": 197.5,
                "searchClicksRivalAvg": 13.6,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 2792,
                "natureSearchImpsRivalGood": 2237.0,
                "natureSearchImpsRivalAvg": 689.7,
                "p4pExposureCntRivalGood": 1388.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 161.0,
                "orderAmount": 0,
                "p4pClickCnt": 36,
                "orderCountRivalGood": 1.0,
                "tmUvRivalAvg": 0.8,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-02-27",
                "shopUv": 496,
                "p4pClickCntRivalGood": 15.0,
                "searchImpsRivalGood": 3625.0,
                "fbUv": 9,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.8,
                "natureSearchImps": 5337,
                "fbPv": 9,
                "shopPvRivalAvg": 42.4,
                "searchClicks": 197,
                "p4pClickCntRivalAvg": 4.0,
                "p4pExposureCntRivalAvg": 652.7,
                "shopPv": 816,
                "searchImpsRivalAvg": 1342.4,
                "shopUvRivalGood": 98.0,
                "statDate": "2019-02-27",
                "tmUvRivalGood": 3.0,
                "natureSearchClicksRivalGood": 31.0,
                "searchClicksRivalGood": 46.0,
                "natureClickCnt": 0,
                "tmUv": 4,
                "orderAmountRivalGood": 3081.0,
                "searchImps": 8129
            },
            {
                "shopUvRivalAvg": 26.8,
                "natureSearchClicks": 249,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 10.799999999999999,
                "orderAmountRivalAvg": 1.2,
                "searchClicksRivalAvg": 14.7,
                "fbUvRivalAvg": 1.0,
                "p4pExposureCnt": 2942,
                "natureSearchImpsRivalGood": 2290.0,
                "natureSearchImpsRivalAvg": 763.9,
                "p4pExposureCntRivalGood": 1712.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 161.0,
                "orderAmount": 0,
                "p4pClickCnt": 36,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.1,
                "fbPvRivalGood": 4.0,
                "statDateRange": "2019-02-26",
                "shopUv": 668,
                "p4pClickCntRivalGood": 13.0,
                "searchImpsRivalGood": 4002.0,
                "fbUv": 6,
                "fbUvRivalGood": 4.0,
                "fbPvRivalAvg": 1.2,
                "natureSearchImps": 6854,
                "fbPv": 7,
                "shopPvRivalAvg": 42.6,
                "searchClicks": 285,
                "p4pClickCntRivalAvg": 3.9,
                "p4pExposureCntRivalAvg": 601.4,
                "shopPv": 1135,
                "searchImpsRivalAvg": 1365.3,
                "shopUvRivalGood": 99.0,
                "statDate": "2019-02-26",
                "tmUvRivalGood": 5.0,
                "natureSearchClicksRivalGood": 35.0,
                "searchClicksRivalGood": 48.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 0.0,
                "searchImps": 9796
            },
            {
                "shopUvRivalAvg": 28.0,
                "natureSearchClicks": 225,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 10.9,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 15.3,
                "fbUvRivalAvg": 0.7,
                "p4pExposureCnt": 3361,
                "natureSearchImpsRivalGood": 2384.0,
                "natureSearchImpsRivalAvg": 763.2,
                "p4pExposureCntRivalGood": 1640.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 1,
                "shopPvRivalGood": 181.0,
                "orderAmount": 2075,
                "p4pClickCnt": 33,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.1,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-02-25",
                "shopUv": 552,
                "p4pClickCntRivalGood": 17.0,
                "searchImpsRivalGood": 4024.0,
                "fbUv": 3,
                "fbUvRivalGood": 3.0,
                "fbPvRivalAvg": 0.9,
                "natureSearchImps": 7227,
                "fbPv": 4,
                "shopPvRivalAvg": 46.8,
                "searchClicks": 258,
                "p4pClickCntRivalAvg": 4.4,
                "p4pExposureCntRivalAvg": 636.5,
                "shopPv": 910,
                "searchImpsRivalAvg": 1399.7,
                "shopUvRivalGood": 107.0,
                "statDate": "2019-02-25",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 33.0,
                "searchClicksRivalGood": 50.0,
                "natureClickCnt": 0,
                "tmUv": 8,
                "orderAmountRivalGood": 0.0,
                "searchImps": 10588
            },
            {
                "shopUvRivalAvg": 26.5,
                "natureSearchClicks": 235,
                "natureExposureCnt": 0,
                "natureSearchClicksRivalAvg": 9.9,
                "orderAmountRivalAvg": 0.0,
                "searchClicksRivalAvg": 13.5,
                "fbUvRivalAvg": 0.6,
                "p4pExposureCnt": 2228,
                "natureSearchImpsRivalGood": 2214.0,
                "natureSearchImpsRivalAvg": 716.4,
                "p4pExposureCntRivalGood": 1486.0,
                "orderCountRivalAvg": 0.0,
                "orderCount": 0,
                "shopPvRivalGood": 197.0,
                "orderAmount": 0,
                "p4pClickCnt": 34,
                "orderCountRivalGood": 0.0,
                "tmUvRivalAvg": 1.1,
                "fbPvRivalGood": 3.0,
                "statDateRange": "2019-02-24",
                "shopUv": 369,
                "p4pClickCntRivalGood": 14.0,
                "searchImpsRivalGood": 3700.0,
                "fbUv": 3,
                "fbUvRivalGood": 2.0,
                "fbPvRivalAvg": 0.7,
                "natureSearchImps": 7408,
                "fbPv": 3,
                "shopPvRivalAvg": 46.7,
                "searchClicks": 269,
                "p4pClickCntRivalAvg": 3.6,
                "p4pExposureCntRivalAvg": 468.6,
                "shopPv": 644,
                "searchImpsRivalAvg": 1185.0,
                "shopUvRivalGood": 112.0,
                "statDate": "2019-02-24",
                "tmUvRivalGood": 4.0,
                "natureSearchClicksRivalGood": 28.0,
                "searchClicksRivalGood": 42.0,
                "natureClickCnt": 0,
                "tmUv": 1,
                "orderAmountRivalGood": 0.0,
                "searchImps": 9636
            }
        ],
        "message": "操作成功",
        "traceId": "0bb3d9a015536727878748122e4c30"
    };

    // 国家及地区分析
    var shopRegionAnalysis = {
        "code": 0,
        "data": [
            {
                "indicatorPercent": 0.2,
                "countryDetail": "Ireland#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "Europe",
                "targetName": "tmUv",
                "targetType": "comp_atm_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "Colombia#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "South America",
                "targetName": "tmUv",
                "targetType": "comp_atm_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "United States#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "North America",
                "targetName": "tmUv",
                "targetType": "comp_atm_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "South Africa#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "Africa",
                "targetName": "tmUv",
                "targetType": "comp_atm_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "Bangladesh#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "Asia",
                "targetName": "tmUv",
                "targetType": "comp_atm_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.3651,
                "countryDetail": "Spain#14.0#0.0444;Italy#12.0#0.0381;France#9.0#0.0286;Germany#9.0#0.0286;Netherlands#9.0#0.0286;Russian Federation#8.0#0.0254;Greece#7.0#0.0222;United Kingdom#6.0#0.019;Sweden#5.0#0.0159;Bosnia and Herzegovina#4.0#0.0127;",
                "indicatorValue": 115.0,
                "regionName": "Europe",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1714,
                "countryDetail": "United States#44.0#0.1397;Canada#8.0#0.0254;Mexico#2.0#0.0063;",
                "indicatorValue": 54.0,
                "regionName": "North America",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1302,
                "countryDetail": "India#9.0#0.0286;Malaysia#8.0#0.0254;Philippines#5.0#0.0159;South Korea#4.0#0.0127;Singapore#2.0#0.0063;Thailand#2.0#0.0063;Cambodia#2.0#0.0063;Bangladesh#2.0#0.0063;Pakistan#1.0#0.0032;Sri Lanka#1.0#0.0032;",
                "indicatorValue": 41.0,
                "regionName": "Asia",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0952,
                "countryDetail": "Brazil#9.0#0.0286;Colombia#4.0#0.0127;Argentina#3.0#0.0095;Costa Rica#2.0#0.0063;Chile#2.0#0.0063;Aruba#2.0#0.0063;Dominican Republic#1.0#0.0032;Nicaragua#1.0#0.0032;Trinidad and Tobago#1.0#0.0032;Peru#1.0#0.0032;",
                "indicatorValue": 30.0,
                "regionName": "South America",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.073,
                "countryDetail": "Turkey#7.0#0.0222;Cyprus#4.0#0.0127;Israel#4.0#0.0127;Saudi Arabia#2.0#0.0063;United Arab Emirates#2.0#0.0063;Oman#2.0#0.0063;Kuwait#1.0#0.0032;Bahrain#1.0#0.0032;",
                "indicatorValue": 23.0,
                "regionName": "Middle East",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0698,
                "countryDetail": "South Africa#8.0#0.0254;Mauritius#3.0#0.0095;Morocco#3.0#0.0095;Kenya#2.0#0.0063;Botswana#2.0#0.0063;Ethiopia#1.0#0.0032;Cameroon#1.0#0.0032;Reunion#1.0#0.0032;Tunisia#1.0#0.0032;",
                "indicatorValue": 22.0,
                "regionName": "Africa",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0476,
                "countryDetail": "Australia#8.0#0.0254;New Zealand#7.0#0.0222;",
                "indicatorValue": 15.0,
                "regionName": "Oceania",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0476,
                "countryDetail": "Other#11.0#0.0349;Curacao#2.0#0.0063;Guam#1.0#0.0032;ISLE OF MAN#1.0#0.0032;",
                "indicatorValue": 15.0,
                "regionName": "Other",
                "targetName": "searchClicks",
                "targetType": "comp_clk_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.5714,
                "countryDetail": "Botswana#3.0#0.4286;South Africa#1.0#0.1429;",
                "indicatorValue": 4.0,
                "regionName": "Africa",
                "targetName": "fbPv",
                "targetType": "comp_fb_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1429,
                "countryDetail": "New Zealand#1.0#0.1429;",
                "indicatorValue": 1.0,
                "regionName": "Oceania",
                "targetName": "fbPv",
                "targetType": "comp_fb_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1429,
                "countryDetail": "Chile#1.0#0.1429;",
                "indicatorValue": 1.0,
                "regionName": "South America",
                "targetName": "fbPv",
                "targetType": "comp_fb_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1429,
                "countryDetail": "Papua New Guinea#1.0#0.1429;",
                "indicatorValue": 1.0,
                "regionName": "Asia",
                "targetName": "fbPv",
                "targetType": "comp_fb_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.4,
                "countryDetail": "South Africa#1.0#0.2;Botswana#1.0#0.2;",
                "indicatorValue": 2.0,
                "regionName": "Africa",
                "targetName": "fbUv",
                "targetType": "comp_fb_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "Chile#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "South America",
                "targetName": "fbUv",
                "targetType": "comp_fb_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "Papua New Guinea#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "Asia",
                "targetName": "fbUv",
                "targetType": "comp_fb_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.2,
                "countryDetail": "New Zealand#1.0#0.2;",
                "indicatorValue": 1.0,
                "regionName": "Oceania",
                "targetName": "fbUv",
                "targetType": "comp_fb_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.3016,
                "countryDetail": "Germany#288.0#0.0305;United Kingdom#280.0#0.0296;Spain#254.0#0.0269;Italy#254.0#0.0269;France#246.0#0.026;Russian Federation#194.0#0.0205;Netherlands#145.0#0.0153;Greece#122.0#0.0129;Hungary#71.0#0.0075;Ukraine#70.0#0.0074;",
                "indicatorValue": 2850.0,
                "regionName": "Europe",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1633,
                "countryDetail": "United States#1251.0#0.1324;Canada#197.0#0.0208;Mexico#95.0#0.0101;",
                "indicatorValue": 1543.0,
                "regionName": "North America",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1555,
                "countryDetail": "India#521.0#0.0551;Philippines#143.0#0.0151;South Korea#107.0#0.0113;Malaysia#107.0#0.0113;Thailand#68.0#0.0072;Indonesia#66.0#0.007;Nepal#58.0#0.0061;Pakistan#50.0#0.0053;Bangladesh#44.0#0.0047;Vietnam#40.0#0.0042;",
                "indicatorValue": 1470.0,
                "regionName": "Asia",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1035,
                "countryDetail": "Brazil#295.0#0.0312;Argentina#166.0#0.0176;Chile#148.0#0.0157;Colombia#60.0#0.0063;Peru#34.0#0.0036;Trinidad and Tobago#31.0#0.0033;Uruguay#31.0#0.0033;Paraguay#28.0#0.003;Costa Rica#21.0#0.0022;Dominican Republic#17.0#0.0018;",
                "indicatorValue": 978.0,
                "regionName": "South America",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0995,
                "countryDetail": "Turkey#296.0#0.0313;Saudi Arabia#160.0#0.0169;United Arab Emirates#132.0#0.014;Israel#57.0#0.006;Cyprus#55.0#0.0058;Lebanon#52.0#0.0055;Qatar#48.0#0.0051;Iraq#37.0#0.0039;Oman#28.0#0.003;Bahrain#26.0#0.0028;",
                "indicatorValue": 940.0,
                "regionName": "Middle East",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0844,
                "countryDetail": "South Africa#172.0#0.0182;Morocco#74.0#0.0078;Egypt#64.0#0.0068;Ghana#48.0#0.0051;Nigeria#42.0#0.0044;Algeria#37.0#0.0039;Angola#37.0#0.0039;Tunisia#32.0#0.0034;Kenya#32.0#0.0034;Botswana#25.0#0.0026;",
                "indicatorValue": 798.0,
                "regionName": "Africa",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0536,
                "countryDetail": "Other#431.0#0.0456;ISLE OF MAN#18.0#0.0019;French Polynesia#12.0#0.0013;Guam#11.0#0.0012;Fiji#11.0#0.0012;Curacao#6.0#0.0006;MONTENEGRO#5.0#0.0005;New Caledonia#4.0#0.0004;Bonaire#1.0#0.0001;American Samoa#1.0#0.0001;",
                "indicatorValue": 507.0,
                "regionName": "Other",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0386,
                "countryDetail": "Australia#264.0#0.0279;New Zealand#101.0#0.0107;",
                "indicatorValue": 365.0,
                "regionName": "Oceania",
                "targetName": "searchImps",
                "targetType": "comp_imps_cnt",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.3118,
                "countryDetail": "Russian Federation#48.0#0.0425;Germany#39.0#0.0345;France#34.0#0.0301;Spain#29.0#0.0257;Italy#25.0#0.0221;Poland#18.0#0.0159;Portugal#12.0#0.0106;Romania#12.0#0.0106;Greece#12.0#0.0106;Netherlands#11.0#0.0097;",
                "indicatorValue": 352.0,
                "regionName": "Europe",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1798,
                "countryDetail": "United States#157.0#0.1391;Canada#29.0#0.0257;Mexico#17.0#0.0151;",
                "indicatorValue": 203.0,
                "regionName": "North America",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1329,
                "countryDetail": "India#34.0#0.0301;Malaysia#24.0#0.0213;Bangladesh#16.0#0.0142;Vietnam#12.0#0.0106;Philippines#9.0#0.008;Indonesia#8.0#0.0071;South Korea#5.0#0.0044;Thailand#5.0#0.0044;Cambodia#3.0#0.0027;Sri Lanka#3.0#0.0027;",
                "indicatorValue": 150.0,
                "regionName": "Asia",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1213,
                "countryDetail": "Turkey#33.0#0.0292;Saudi Arabia#24.0#0.0213;Oman#22.0#0.0195;Cyprus#17.0#0.0151;United Arab Emirates#10.0#0.0089;Bahrain#8.0#0.0071;Israel#8.0#0.0071;Palestine#5.0#0.0044;Kuwait#5.0#0.0044;Jordan#3.0#0.0027;",
                "indicatorValue": 137.0,
                "regionName": "Middle East",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1036,
                "countryDetail": "Brazil#27.0#0.0239;Trinidad and Tobago#15.0#0.0133;Chile#12.0#0.0106;Argentina#10.0#0.0089;Peru#8.0#0.0071;Costa Rica#8.0#0.0071;Colombia#7.0#0.0062;Dominican Republic#5.0#0.0044;Guatemala#3.0#0.0027;Ecuador#3.0#0.0027;",
                "indicatorValue": 117.0,
                "regionName": "South America",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1019,
                "countryDetail": "South Africa#57.0#0.0505;Botswana#14.0#0.0124;Morocco#11.0#0.0097;Mauritius#5.0#0.0044;Kenya#5.0#0.0044;Senegal#4.0#0.0035;Zambia#4.0#0.0035;Cameroon#3.0#0.0027;Somalia#2.0#0.0018;Ghana#2.0#0.0018;",
                "indicatorValue": 115.0,
                "regionName": "Africa",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0363,
                "countryDetail": "Australia#26.0#0.023;New Zealand#15.0#0.0133;",
                "indicatorValue": 41.0,
                "regionName": "Oceania",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0124,
                "countryDetail": "Curacao#7.0#0.0062;ISLE OF MAN#2.0#0.0018;Other#2.0#0.0018;Guam#1.0#0.0009;French Polynesia#1.0#0.0009;Marshall Islands#1.0#0.0009;",
                "indicatorValue": 14.0,
                "regionName": "Other",
                "targetName": "shopPv",
                "targetType": "shop_pv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.3537,
                "countryDetail": "France#23.0#0.038;Spain#23.0#0.038;Russian Federation#22.0#0.0364;Germany#20.0#0.0331;Italy#17.0#0.0281;Portugal#11.0#0.0182;Netherlands#10.0#0.0165;United Kingdom#8.0#0.0132;Greece#8.0#0.0132;Romania#5.0#0.0083;",
                "indicatorValue": 214.0,
                "regionName": "Europe",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1636,
                "countryDetail": "United States#74.0#0.1223;Canada#15.0#0.0248;Mexico#10.0#0.0165;",
                "indicatorValue": 99.0,
                "regionName": "North America",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1405,
                "countryDetail": "India#22.0#0.0364;Malaysia#11.0#0.0182;Philippines#6.0#0.0099;South Korea#5.0#0.0083;Thailand#5.0#0.0083;Indonesia#4.0#0.0066;Vietnam#4.0#0.0066;Azerbaijan#3.0#0.005;Kyrgyzstan#3.0#0.005;Sri Lanka#2.0#0.0033;",
                "indicatorValue": 85.0,
                "regionName": "Asia",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1124,
                "countryDetail": "Turkey#14.0#0.0231;Saudi Arabia#11.0#0.0182;United Arab Emirates#9.0#0.0149;Oman#8.0#0.0132;Israel#7.0#0.0116;Cyprus#7.0#0.0116;Kuwait#4.0#0.0066;Bahrain#3.0#0.005;Palestine#2.0#0.0033;Lebanon#1.0#0.0017;",
                "indicatorValue": 68.0,
                "regionName": "Middle East",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.1091,
                "countryDetail": "Brazil#15.0#0.0248;Argentina#8.0#0.0132;Chile#7.0#0.0116;Colombia#7.0#0.0116;Peru#3.0#0.005;Ecuador#3.0#0.005;Uruguay#2.0#0.0033;Trinidad and Tobago#2.0#0.0033;Costa Rica#2.0#0.0033;Nicaragua#2.0#0.0033;",
                "indicatorValue": 66.0,
                "regionName": "South America",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0694,
                "countryDetail": "South Africa#13.0#0.0215;Morocco#5.0#0.0083;Mauritius#3.0#0.005;Botswana#3.0#0.005;Kenya#3.0#0.005;Ghana#2.0#0.0033;Zambia#2.0#0.0033;Swaziland#1.0#0.0017;Libyan Arab Jamahiriya#1.0#0.0017;Cote D'Ivoire#1.0#0.0017;",
                "indicatorValue": 42.0,
                "regionName": "Africa",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0347,
                "countryDetail": "Australia#14.0#0.0231;New Zealand#7.0#0.0116;",
                "indicatorValue": 21.0,
                "regionName": "Oceania",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            },
            {
                "indicatorPercent": 0.0165,
                "countryDetail": "Curacao#4.0#0.0066;Other#2.0#0.0033;ISLE OF MAN#1.0#0.0017;Guam#1.0#0.0017;Marshall Islands#1.0#0.0017;French Polynesia#1.0#0.0017;",
                "indicatorValue": 10.0,
                "regionName": "Other",
                "targetName": "shopUv",
                "targetType": "shop_uv",
                "statDate": "2019-03-24"
            }
        ],
        "message": "操作成功",
        "traceId": "0b09865515535945569472422e9739"
    };

    // 昨日 - 其他数据
    var offlineShopStats = {
        "code": 0,
        "data": {
            "visitorToFbRate": {//店铺转化率
                "percentPoint": 0.014899999999999998,
                "value": 0.0248
            },
            "fbPv": {//询盘个数
                "wsPercent": 0.4117647058823529,
                "value": 17,
                "cycleCrc": 1.4285714285714284
            },
            "shopUv": {//店铺访问人数
                "wsPercent": 0.7677304964539007,
                "value": 564,
                "cycleCrc": -0.06776859504132227
            },
            "shopPv": {//店铺访问次数
                "wsPercent": 0.755083179297597,
                "value": 1082,
                "cycleCrc": -0.041629760850310005
            },
            "uvTrend": [//折线图
                {
                    "shopUv": 637,
                    "statDate": "2019-03-19"
                },
                {
                    "shopUv": 753,
                    "statDate": "2019-03-20"
                },
                {
                    "shopUv": 726,
                    "statDate": "2019-03-21"
                },
                {
                    "shopUv": 496,
                    "statDate": "2019-03-22"
                },
                {
                    "shopUv": 543,
                    "statDate": "2019-03-23"
                },
                {
                    "shopUv": 605,
                    "statDate": "2019-03-24"
                },
                {
                    "shopUv": 564,
                    "statDate": "2019-03-25"
                }
            ],
            "atmfbVisitorCnt": {//TM咨询人数
                "wsPercent": 0.875,
                "value": 8,
                "cycleCrc": 0.6000000000000001
            }
        },
        "message": "操作成功",
        "traceId": "0b090d4c15536684202341729ea68e"
    };

    // 流量来源
    var trafficSource = {
        "successed": true,
        "value": [
            {
                "fb_uv": 0,
                "channel_type_tip": "包括阿里巴巴国际站旗下各域名网站的首页：www.alibaba.com和m.alibaba.com",
                "visitor_to_fb_rate": "5.6%",
                "visitor_to_fb_rate_lrrate": -16.64,
                "channel_type_display": "首页",
                "fb_uv_lrrate": 0.0,
                "stat_date": "2019-05-11",
                "shop_uv_lrrate": 20.0,
                "fb_mc_uv": 1,
                "shop_uv": 18,
                "channel_type": "首页",
                "fb_mc_uv_lrrate": 0.0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "阿里巴巴国际站全部搜索场景，包括关键词搜索、类目搜索、供应商搜索等",
                "visitor_to_fb_rate": "1.1%",
                "visitor_to_fb_rate_lrrate": 50.0,
                "channel_type_display": "搜索",
                "fb_uv_lrrate": -100.0,
                "stat_date": "2019-05-11",
                "shop_uv_lrrate": -32.6,
                "fb_mc_uv": 1,
                "shop_uv": 93,
                "channel_type": "搜索"
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "买家在勾选金品诚企标识“Verified”后的搜索场景",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0,
                "channel_type_display": "搜索金品诚企",
                "fb_uv_lrrate": 0,
                "shop_uv_lrrate": 0,
                "fb_mc_uv": 0,
                "shop_uv": 0,
                "channel_type": "搜索金品",
                "fb_mc_uv_lrrate": 0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "Top Select Suppliers专区带来的流量",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0,
                "channel_type_display": "优商专区",
                "fb_uv_lrrate": 0,
                "shop_uv_lrrate": 0,
                "fb_mc_uv": 0,
                "shop_uv": 0,
                "channel_type": "优商专区",
                "fb_mc_uv_lrrate": 0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "卖家投放的粉丝内容（Feeds）",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0.0,
                "channel_type_display": "粉丝通",
                "fb_uv_lrrate": 0.0,
                "stat_date": "2019-05-11",
                "shop_uv_lrrate": 100.0,
                "fb_mc_uv": 0,
                "shop_uv": 2,
                "channel_type": "粉丝通",
                "fb_mc_uv_lrrate": 0.0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "无线Weakly Deals频道",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0,
                "channel_type_display": "Weekly Deals",
                "fb_uv_lrrate": 0,
                "shop_uv_lrrate": 0,
                "fb_mc_uv": 0,
                "shop_uv": 0,
                "channel_type": "Weekly Deals",
                "fb_mc_uv_lrrate": 0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "买家通过外贸服务市场的站外推广工具访问",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0,
                "channel_type_display": "外服站外推广",
                "fb_uv_lrrate": 0,
                "shop_uv_lrrate": 0,
                "fb_mc_uv": 0,
                "shop_uv": 0,
                "channel_type": "外部ISV投放",
                "fb_mc_uv_lrrate": 0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "买家直接到访商家页面",
                "visitor_to_fb_rate": "0.0%",
                "visitor_to_fb_rate_lrrate": 0.0,
                "channel_type_display": "直接访问",
                "fb_uv_lrrate": 0.0,
                "stat_date": "2019-05-11",
                "shop_uv_lrrate": -10.0,
                "fb_mc_uv": 0,
                "shop_uv": 18,
                "channel_type": "直接访问",
                "fb_mc_uv_lrrate": 0.0
            },
            {
                "fb_uv": 0,
                "channel_type_tip": "其它未归属页面（包括阿里巴巴国际站站内以及站外页面）",
                "visitor_to_fb_rate": "3.7%",
                "visitor_to_fb_rate_lrrate": 4.87,
                "channel_type_display": "其他",
                "fb_uv_lrrate": -100.0,
                "stat_date": "2019-05-11",
                "shop_uv_lrrate": -4.65,
                "fb_mc_uv": 3,
                "shop_uv": 82,
                "channel_type": "其他",
                "fb_mc_uv_lrrate": 50.0
            }
        ]
    };

    // 店铺效果
    var storeEffect = {
        "successed": true,
        "value": {
            "fbUvCnt": {//店铺询盘人数
                "wowDiff": "-33.3",
                "avgTop10": "6",
                "value": 2,
                "wowDiffIndustry": "1.9",
                "wowDiffTop10": "61.9",
                "avgIndustry": "1",
                "trends": [
                    {
                        "avgTop10": "5",
                        "self": 5,
                        "avg": "1",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "5",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "8",
                        "self": 6,
                        "avg": "2",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "7",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "6",
                        "self": 7,
                        "avg": "1",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "5",
                        "self": 4,
                        "avg": "1",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "4",
                        "self": 1,
                        "avg": "1",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "5",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "5",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "6",
                        "self": 1,
                        "avg": "2",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "5",
                        "self": 5,
                        "avg": "2",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "5",
                        "self": 9,
                        "avg": "1",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "7",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "8",
                        "self": 1,
                        "avg": "1",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "7",
                        "self": 5,
                        "avg": "1",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "5",
                        "self": 3,
                        "avg": "1",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "7",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "7",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "4",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "4",
                        "self": 3,
                        "avg": "1",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "6",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "5",
                        "self": 8,
                        "avg": "1",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "7",
                        "self": 3,
                        "avg": "1",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "7",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "3",
                        "self": 5,
                        "avg": "1",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "5",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-11"
                    }
                ]
            },
            "mcfbCnt": {//店铺询盘个数
                "wowDiff": "66.6",
                "avgTop10": "8",
                "value": 5,
                "wowDiffIndustry": "9.1",
                "wowDiffTop10": "73.9",
                "avgIndustry": "2",
                "trends": [
                    {
                        "avgTop10": "6",
                        "self": 7,
                        "avg": "2",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "5",
                        "self": 6,
                        "avg": "2",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "8",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "8",
                        "self": 6,
                        "avg": "2",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "7",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "6",
                        "self": 7,
                        "avg": "2",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "6",
                        "self": 4,
                        "avg": "2",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "6",
                        "self": 1,
                        "avg": "2",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "6",
                        "self": 1,
                        "avg": "2",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "6",
                        "self": 5,
                        "avg": "2",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "5",
                        "self": 10,
                        "avg": "2",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "7",
                        "self": 4,
                        "avg": "2",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "9",
                        "self": 1,
                        "avg": "2",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "8",
                        "self": 6,
                        "avg": "2",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "7",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "6",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "8",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "8",
                        "self": 2,
                        "avg": "2",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "5",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "4",
                        "self": 3,
                        "avg": "1",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "7",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "6",
                        "self": 8,
                        "avg": "2",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "8",
                        "self": 3,
                        "avg": "2",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "8",
                        "self": 5,
                        "avg": "2",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "3",
                        "self": 5,
                        "avg": "1",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "6",
                        "self": 2,
                        "avg": "1",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "8",
                        "self": 5,
                        "avg": "2",
                        "date": "2019-05-11"
                    }
                ]
            },
            "atmfbVisitorCnt": {//店铺TM咨询人数
                "wowDiff": "0.0",
                "avgTop10": "2",
                "value": 1,
                "wowDiffIndustry": "16.0",
                "wowDiffTop10": "33.3",
                "avgIndustry": "0",
                "trends": [
                    {
                        "avgTop10": "1",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "1",
                        "self": 5,
                        "avg": "0",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "1",
                        "self": 4,
                        "avg": "0",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "2",
                        "self": 3,
                        "avg": "0",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "3",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "1",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "1",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "3",
                        "self": 3,
                        "avg": "0",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "3",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "2",
                        "self": 2,
                        "avg": "0",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "2",
                        "self": 3,
                        "avg": "0",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "3",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "1",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "3",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "1",
                        "self": 0,
                        "avg": "0",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "2",
                        "self": 1,
                        "avg": "0",
                        "date": "2019-05-11"
                    }
                ]
            },
            "pageVisitCnt": {//店铺访问次数
                "wowDiff": "-30.7",
                "avgTop10": "752",
                "value": 259,
                "wowDiffIndustry": "-6.3",
                "wowDiffTop10": "-9.5",
                "avgIndustry": "240",
                "trends": [
                    {
                        "avgTop10": "602",
                        "self": 525,
                        "avg": "237",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "664",
                        "self": 508,
                        "avg": "260",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "766",
                        "self": 484,
                        "avg": "286",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "608",
                        "self": 552,
                        "avg": "286",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "582",
                        "self": 384,
                        "avg": "268",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "626",
                        "self": 393,
                        "avg": "241",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "704",
                        "self": 343,
                        "avg": "256",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "626",
                        "self": 396,
                        "avg": "278",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "703",
                        "self": 406,
                        "avg": "324",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "829",
                        "self": 459,
                        "avg": "370",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "760",
                        "self": 538,
                        "avg": "368",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "679",
                        "self": 384,
                        "avg": "350",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "701",
                        "self": 423,
                        "avg": "300",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "1526",
                        "self": 386,
                        "avg": "281",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "1311",
                        "self": 385,
                        "avg": "247",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "1270",
                        "self": 310,
                        "avg": "256",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "1443",
                        "self": 417,
                        "avg": "319",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "1504",
                        "self": 254,
                        "avg": "269",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "1496",
                        "self": 339,
                        "avg": "272",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "1328",
                        "self": 340,
                        "avg": "273",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "943",
                        "self": 361,
                        "avg": "253",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "908",
                        "self": 403,
                        "avg": "253",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "831",
                        "self": 374,
                        "avg": "256",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "929",
                        "self": 422,
                        "avg": "291",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "678",
                        "self": 308,
                        "avg": "237",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "650",
                        "self": 320,
                        "avg": "249",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "710",
                        "self": 284,
                        "avg": "244",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "854",
                        "self": 277,
                        "avg": "233",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "678",
                        "self": 356,
                        "avg": "227",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "752",
                        "self": 259,
                        "avg": "240",
                        "date": "2019-05-11"
                    }
                ]
            },
            "visitorCnt": {//店铺访问人数
                "wowDiff": "-14.3",
                "avgTop10": "394",
                "value": 161,
                "wowDiffIndustry": "-10.5",
                "wowDiffTop10": "-9.3",
                "avgIndustry": "124",
                "trends": [
                    {
                        "avgTop10": "317",
                        "self": 265,
                        "avg": "128",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "346",
                        "self": 260,
                        "avg": "136",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "414",
                        "self": 291,
                        "avg": "154",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "332",
                        "self": 268,
                        "avg": "151",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "326",
                        "self": 266,
                        "avg": "146",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "342",
                        "self": 222,
                        "avg": "132",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "375",
                        "self": 220,
                        "avg": "138",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "348",
                        "self": 242,
                        "avg": "149",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "374",
                        "self": 229,
                        "avg": "175",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "436",
                        "self": 274,
                        "avg": "198",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "380",
                        "self": 289,
                        "avg": "195",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "368",
                        "self": 241,
                        "avg": "185",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "401",
                        "self": 233,
                        "avg": "159",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "756",
                        "self": 227,
                        "avg": "148",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "667",
                        "self": 214,
                        "avg": "133",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "642",
                        "self": 188,
                        "avg": "138",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "757",
                        "self": 243,
                        "avg": "167",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "822",
                        "self": 170,
                        "avg": "144",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "807",
                        "self": 203,
                        "avg": "147",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "693",
                        "self": 212,
                        "avg": "149",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "522",
                        "self": 187,
                        "avg": "140",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "498",
                        "self": 199,
                        "avg": "136",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "435",
                        "self": 188,
                        "avg": "139",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "476",
                        "self": 217,
                        "avg": "157",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "367",
                        "self": 158,
                        "avg": "130",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "346",
                        "self": 185,
                        "avg": "132",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "370",
                        "self": 154,
                        "avg": "134",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "440",
                        "self": 164,
                        "avg": "125",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "368",
                        "self": 185,
                        "avg": "122",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "394",
                        "self": 161,
                        "avg": "124",
                        "date": "2019-05-11"
                    }
                ]
            },
            "visitorToFbRate": {//店铺转化率
                "wowDiff": "-12.6",
                "avgTop10": "4.2",
                "value": "1.8",
                "wowDiffIndustry": "-4.8",
                "wowDiffTop10": "56.2",
                "avgIndustry": "1.7",
                "trends": [
                    {
                        "avgTop10": "4.6",
                        "self": "2.2",
                        "avg": "2.1",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "2.9",
                        "self": "2.6",
                        "avg": "1.5",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "2.6",
                        "self": "1.0",
                        "avg": "2.8",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "4.4",
                        "self": "3.7",
                        "avg": "2.4",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "4.2",
                        "self": "1.1",
                        "avg": "3.2",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "3.7",
                        "self": "4.5",
                        "avg": "2.7",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "2.9",
                        "self": "1.8",
                        "avg": "2.2",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "2.7",
                        "self": "0.8",
                        "avg": "1.7",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "3.0",
                        "self": "0.8",
                        "avg": "1.5",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "2.8",
                        "self": "1.0",
                        "avg": "2.8",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "2.6",
                        "self": "0.6",
                        "avg": "1.8",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "2.8",
                        "self": "2.0",
                        "avg": "1.8",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "2.8",
                        "self": "4.2",
                        "avg": "3.2",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "3.9",
                        "self": "2.6",
                        "avg": "1.9",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "3.6",
                        "self": "0.4",
                        "avg": "2.5",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "2.2",
                        "self": "3.7",
                        "avg": "1.6",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "2.6",
                        "self": "1.2",
                        "avg": "1.6",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "2.2",
                        "self": "3.5",
                        "avg": "1.9",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "2.8",
                        "self": "0.9",
                        "avg": "1.6",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "2.4",
                        "self": "0.9",
                        "avg": "2.2",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "3.6",
                        "self": "1.0",
                        "avg": "1.8",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "2.0",
                        "self": "1.0",
                        "avg": "1.9",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "2.7",
                        "self": "2.1",
                        "avg": "1.8",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "3.8",
                        "self": "1.8",
                        "avg": "2.2",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "3.2",
                        "self": "5.0",
                        "avg": "3.2",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "4.3",
                        "self": "1.6",
                        "avg": "2.5",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "3.6",
                        "self": "1.9",
                        "avg": "2.4",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "2.7",
                        "self": "3.0",
                        "avg": "2.0",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "2.5",
                        "self": "1.0",
                        "avg": "1.8",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "4.2",
                        "self": "1.8",
                        "avg": "1.7",
                        "date": "2019-05-11"
                    }
                ]
            }
        }
    };

    // 访问行为
    var accessBehavior = {
        "successed": true,
        "value": {
            "visitorAvgDur": {//人均访问时长（秒）
                "wowDiff": "-19.1",
                "avgTop10": "75",
                "value": 59,
                "wowDiffIndustry": "-4.7",
                "wowDiffTop10": "0.9",
                "avgIndustry": "62",
                "trends": [
                    {
                        "avgTop10": "91",
                        "self": 104,
                        "avg": "72",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "93",
                        "self": 73,
                        "avg": "70",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "88",
                        "self": 71,
                        "avg": "68",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "79",
                        "self": 84,
                        "avg": "67",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "98",
                        "self": 59,
                        "avg": "71",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "78",
                        "self": 78,
                        "avg": "70",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "71",
                        "self": 50,
                        "avg": "64",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "87",
                        "self": 61,
                        "avg": "64",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "87",
                        "self": 57,
                        "avg": "57",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "88",
                        "self": 51,
                        "avg": "64",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "85",
                        "self": 66,
                        "avg": "58",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "71",
                        "self": 46,
                        "avg": "60",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "76",
                        "self": 66,
                        "avg": "55",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "88",
                        "self": 69,
                        "avg": "57",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "75",
                        "self": 77,
                        "avg": "66",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "81",
                        "self": 75,
                        "avg": "61",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "83",
                        "self": 72,
                        "avg": "59",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "76",
                        "self": 58,
                        "avg": "59",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "82",
                        "self": 56,
                        "avg": "74",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "70",
                        "self": 47,
                        "avg": "57",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "76",
                        "self": 70,
                        "avg": "56",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "64",
                        "self": 71,
                        "avg": "57",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "75",
                        "self": 73,
                        "avg": "65",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "74",
                        "self": 69,
                        "avg": "59",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "74",
                        "self": 69,
                        "avg": "58",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "62",
                        "self": 76,
                        "avg": "61",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "74",
                        "self": 56,
                        "avg": "71",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "85",
                        "self": 62,
                        "avg": "65",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "76",
                        "self": 70,
                        "avg": "70",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "75",
                        "self": 59,
                        "avg": "62",
                        "date": "2019-05-11"
                    }
                ]
            },
            "visitorAvgPgCnt": {//人均访问页面个数
                "wowDiff": "-19.1",
                "avgTop10": "1.99",
                "value": "1.60",
                "wowDiffIndustry": "-5.7",
                "wowDiffTop10": "1.3",
                "avgIndustry": "1.70",
                "trends": [
                    {
                        "avgTop10": "2.00",
                        "self": "1.98",
                        "avg": "1.69",
                        "date": "2019-04-12"
                    },
                    {
                        "avgTop10": "2.01",
                        "self": "1.95",
                        "avg": "1.76",
                        "date": "2019-04-13"
                    },
                    {
                        "avgTop10": "1.87",
                        "self": "1.66",
                        "avg": "1.72",
                        "date": "2019-04-14"
                    },
                    {
                        "avgTop10": "1.87",
                        "self": "2.05",
                        "avg": "1.77",
                        "date": "2019-04-15"
                    },
                    {
                        "avgTop10": "1.86",
                        "self": "1.44",
                        "avg": "1.70",
                        "date": "2019-04-16"
                    },
                    {
                        "avgTop10": "1.81",
                        "self": "1.77",
                        "avg": "1.65",
                        "date": "2019-04-17"
                    },
                    {
                        "avgTop10": "1.94",
                        "self": "1.55",
                        "avg": "1.69",
                        "date": "2019-04-18"
                    },
                    {
                        "avgTop10": "1.90",
                        "self": "1.63",
                        "avg": "1.69",
                        "date": "2019-04-19"
                    },
                    {
                        "avgTop10": "1.93",
                        "self": "1.77",
                        "avg": "1.65",
                        "date": "2019-04-20"
                    },
                    {
                        "avgTop10": "2.01",
                        "self": "1.67",
                        "avg": "1.76",
                        "date": "2019-04-21"
                    },
                    {
                        "avgTop10": "2.05",
                        "self": "1.86",
                        "avg": "1.73",
                        "date": "2019-04-22"
                    },
                    {
                        "avgTop10": "2.03",
                        "self": "1.59",
                        "avg": "1.75",
                        "date": "2019-04-23"
                    },
                    {
                        "avgTop10": "1.93",
                        "self": "1.81",
                        "avg": "1.70",
                        "date": "2019-04-24"
                    },
                    {
                        "avgTop10": "2.12",
                        "self": "1.70",
                        "avg": "1.72",
                        "date": "2019-04-25"
                    },
                    {
                        "avgTop10": "1.97",
                        "self": "1.79",
                        "avg": "1.67",
                        "date": "2019-04-26"
                    },
                    {
                        "avgTop10": "1.91",
                        "self": "1.64",
                        "avg": "1.67",
                        "date": "2019-04-27"
                    },
                    {
                        "avgTop10": "2.02",
                        "self": "1.71",
                        "avg": "1.82",
                        "date": "2019-04-28"
                    },
                    {
                        "avgTop10": "2.02",
                        "self": "1.49",
                        "avg": "1.73",
                        "date": "2019-04-29"
                    },
                    {
                        "avgTop10": "1.89",
                        "self": "1.67",
                        "avg": "1.82",
                        "date": "2019-04-30"
                    },
                    {
                        "avgTop10": "1.92",
                        "self": "1.60",
                        "avg": "1.68",
                        "date": "2019-05-01"
                    },
                    {
                        "avgTop10": "1.87",
                        "self": "1.93",
                        "avg": "1.67",
                        "date": "2019-05-02"
                    },
                    {
                        "avgTop10": "1.86",
                        "self": "2.02",
                        "avg": "1.71",
                        "date": "2019-05-03"
                    },
                    {
                        "avgTop10": "1.97",
                        "self": "1.98",
                        "avg": "1.80",
                        "date": "2019-05-04"
                    },
                    {
                        "avgTop10": "1.89",
                        "self": "1.94",
                        "avg": "1.82",
                        "date": "2019-05-05"
                    },
                    {
                        "avgTop10": "1.92",
                        "self": "1.94",
                        "avg": "1.70",
                        "date": "2019-05-06"
                    },
                    {
                        "avgTop10": "1.93",
                        "self": "1.72",
                        "avg": "1.75",
                        "date": "2019-05-07"
                    },
                    {
                        "avgTop10": "1.92",
                        "self": "1.84",
                        "avg": "1.69",
                        "date": "2019-05-08"
                    },
                    {
                        "avgTop10": "1.94",
                        "self": "1.68",
                        "avg": "1.69",
                        "date": "2019-05-09"
                    },
                    {
                        "avgTop10": "1.85",
                        "self": "1.92",
                        "avg": "1.77",
                        "date": "2019-05-10"
                    },
                    {
                        "avgTop10": "1.99",
                        "self": "1.60",
                        "avg": "1.70",
                        "date": "2019-05-11"
                    }
                ]
            }
        }
    };

    // 店铺访问详情
    var visitorsDetail = {
        "successed": true,
        "value": [
            {
                "minisiteTypeRanking": 1,
                "clickCnt": 4,
                "mcfbCnt": 0,
                "visitorCnt": 4,
                "minisiteTypeDesc": "Home",
                "atmfbVisitorCnt": 0,
                "avgStayDur": 26.2500,
                "url": "https://siteadmin.alibaba.com/page.htm?name=index"
            },
            {
                "minisiteTypeRanking": 2,
                "clickCnt": 0,
                "mcfbCnt": 0,
                "visitorCnt": 2,
                "minisiteTypeDesc": "Product Categories",
                "atmfbVisitorCnt": 0,
                "avgStayDur": 48.5000,
                "url": "https://siteadmin.alibaba.com/page.htm?name=products"
            },
            {
                "minisiteTypeRanking": 3,
                "clickCnt": 0,
                "mcfbCnt": 0,
                "visitorCnt": 2,
                "minisiteTypeDesc": "Company Profile",
                "atmfbVisitorCnt": 0,
                "avgStayDur": 11.5000,
                "url": "https://siteadmin.alibaba.com/page.htm?name=companyProfile"
            },
            {
                "minisiteTypeRanking": 4,
                "clickCnt": 0,
                "mcfbCnt": 0,
                "visitorCnt": 2,
                "minisiteTypeDesc": "Contacts",
                "atmfbVisitorCnt": 0,
                "avgStayDur": 624.5000,
                "url": "https://siteadmin.alibaba.com/page.htm?name=contacts"
            },
            {
                "minisiteTypeRanking": 5,
                "clickCnt": 0,
                "mcfbCnt": 2,
                "visitorCnt": 220,
                "minisiteTypeDesc": "Detail",
                "atmfbVisitorCnt": 1,
                "avgStayDur": 67.2864,
                "url": "https://siteadmin.alibaba.com/page.htm?name=custom_page"
            }
        ]
    };

    var DAY_TIMES_TAMP = 24 * 3.6e3 * 1e3;

    var resData = {
        keywords: hotKeyWord.data.splice(0, 5),
        products: topProduct.value.splice(0, 5).map(function (value) {
            value.imageURL = '../images/data-admin/' + value.imageURL;
            return value;
        }),
        industries: industries.value,
        realTimeShopStats: {
            fbPv: realTimeShopStats.data.fbPv,
            shopUv: realTimeShopStats.data.shopUv,
            shopPv: realTimeShopStats.data.shopPv,
            realtimeTrend: realTimeShopVisitorTrend.data.map(function (value) {
                return {
                    key: value.statHour + ':00',
                    value: value.shopUv
                }
            }),
            previousTrend: previousShopVisitorTrend.data.map(function (value) {
                return {
                    key: value.statHour + ':00',
                    value: value.shopUv
                }
            }),
            statDate: new Date(DSSX.util.getServerCurrentTime().getTime() - 2 * DAY_TIMES_TAMP).getTime()
        },
        offlineShopStats: {
            conversionRate: offlineShopStats.data.visitorToFbRate,
            fbPv: offlineShopStats.data.fbPv,
            shopUv: offlineShopStats.data.shopUv,
            shopPv: offlineShopStats.data.shopPv,
            tmCount: offlineShopStats.data.atmfbVisitorCnt,
            uvTrend: offlineShopStats.data.uvTrend.map(function (value, index, array) {
                return {
                    key: new Date(DSSX.util.getServerCurrentTime().getTime() - (array.length - index) * DAY_TIMES_TAMP).getTime(),
                    value: value.shopUv
                }
            })
        },
        shopSummary: {
            realtime: {
                date: new Date(DSSX.util.getServerCurrentTime().getTime() - 2 * DAY_TIMES_TAMP).getTime(),
                shopUv: shopSummary.data[0].shopUv,
                shopPv: shopSummary.data[0].shopPv,
                searchImps: shopSummary.data[0].searchImps,
                searchClicks: shopSummary.data[0].searchClicks,
                fbUv: shopSummary.data[0].fbUv,
                fbPv: shopSummary.data[0].fbPv,
                tmUv: shopSummary.data[0].tmUv,
                orderCount: shopSummary.data[0].orderCount,
                orderAmount: shopSummary.data[0].orderAmount
            },
            previous: {
                date: new Date(DSSX.util.getServerCurrentTime().getTime() - 3 * DAY_TIMES_TAMP).getTime(),
                shopUv: shopSummary.data[1].shopUv,
                shopPv: shopSummary.data[1].shopPv,
                searchImps: shopSummary.data[1].searchImps,
                searchClicks: shopSummary.data[1].searchClicks,
                fbUv: shopSummary.data[1].fbUv,
                fbPv: shopSummary.data[1].fbPv,
                tmUv: shopSummary.data[1].tmUv,
                orderCount: shopSummary.data[1].orderCount,
                orderAmount: shopSummary.data[1].orderAmount
            }
        },
        shopTrends: {
            shopUv: trimShopTrendsData('shopUv', 'shopUvRivalAvg', 'shopUvRivalGood'),
            shopPv: trimShopTrendsData('shopPv', 'shopPvRivalAvg', 'shopPvRivalGood'),
            searchImps: trimShopTrendsData('searchImps', 'searchImpsRivalAvg', 'searchImpsRivalGood'),
            searchClicks: trimShopTrendsData('searchClicks', 'searchClicksRivalAvg', 'searchClicksRivalGood'),
            fbUv: trimShopTrendsData('fbUv', 'fbUvRivalAvg', 'fbUvRivalGood'),
            fbPv: trimShopTrendsData('fbPv', 'fbPvRivalAvg', 'fbPvRivalGood'),
            tmUv: trimShopTrendsData('tmUv', 'tmUvRivalAvg', 'tmUvRivalGood'),
            orderCount: trimShopTrendsData('orderCount', 'orderCountRivalAvg', 'orderCountRivalGood'),
            orderAmount: trimShopTrendsData('orderAmount', 'orderAmountRivalAvg', 'orderAmountRivalGood')
        },
        shopRegionAnalysis: {
            shopUv: trimShopRegionAnalysisData('shopUv'),
            shopPv: trimShopRegionAnalysisData('shopPv'),
            searchImps: trimShopRegionAnalysisData('searchImps'),
            searchClicks: trimShopRegionAnalysisData('searchClicks'),
            fbUv: trimShopRegionAnalysisData('fbUv'),
            fbPv: trimShopRegionAnalysisData('fbPv'),
            tmUv: trimShopRegionAnalysisData('tmUv')
        },
        trafficSource: trafficSource.value,
        storeEffect: trimStoreData(storeEffect),
        accessBehavior: trimStoreData(accessBehavior),
        visitorsDetail: visitorsDetail.value,
    };

    /**
     * @param arg_mine string 我的效果字段
     * @param arg_average string 行业平均字段
     * @param arg_good string 同行优秀字段
     */
    function trimShopTrendsData(arg_mine, arg_average, arg_good) {
        return shopTrends.data.map(function (value, index, array) {
            return {
                key: new Date(DSSX.util.getServerCurrentTime().getTime() - (array.length - index) * DAY_TIMES_TAMP).getTime(),
                mine: DSSX.util.safe(value, arg_mine, 0),
                average: DSSX.util.safe(value, arg_average, 0),
                good: DSSX.util.safe(value, arg_good, 0)
            }
        }).sort(function (a, b) {
           return a.key - b.key
        });
    }

    /**
     * @param arg_target
     * @returns {any[]}
     */
    function trimShopRegionAnalysisData(arg_target) {
        return shopRegionAnalysis.data.filter(function (value) {
            return value.targetName === arg_target
        }).map(function (value) {
            return {
                key: value.regionName,
                value: value.indicatorPercent,
                detail: value.countryDetail.split(';').map(function (element) {
                    var data = element.split('#');
                    return {
                        key: data[0],
                        value: data[1],
                        percentage: data[2]
                    }
                })
            }
        })
    }

    /**
     * @param argData
     * @returns {object}
     */
    function trimStoreData(argData) {
        var res = {};
        'value' in argData && angular.forEach(argData.value, function (value, key) {
            res[key] = value;
            'trends' in value && (res[key].trends = value.trends.map(function (value, index, array) {
                return {
                    key: new Date(DSSX.util.getServerCurrentTime().getTime() - (array.length - index + 2) * DAY_TIMES_TAMP).getTime(),
                    mine: value.self,
                    average: value.avg,
                    good: value.avgTop10
                }
            }));
        });
        return res;
    }

    angular.module('app.core').constant('dataAdminDiagnosisData', resData);
}();